<template>
  <!-- fin de menu -->
  <div class="container-fluid">
    <div class="card bg-white">
      <!-- inicio de menu promociones -->
      <!-- inicio de menu promociones -->

      <template v-if="listar == 3">
        <div class="card-body">
          <div class="modal-header" style="font-size: 12px; height: 10px">
            <!--<h5
                class="modal-title"
                id="staticBackdropLabel"
                v-text="tituloModal"
              ></h5>-->
            <button
              type="button "
              class="btn-close btn btn-sm"
              data-bs-dismiss="modal"
              @click="cerrarModalVi()"
              aria-label="Close"
            ></button>
          </div>
          <div class="form-group row">
            <!-- Incio Mostrar encabezado promocion -->
            <div class="container">
              <div class="card">
                <div
                  class="text-start fw-bold"
                  style="
                    background: #ebeef6;
                    font-size: 12px;
                    height: 30px;
                    color: #000000;
                  "
                >
                  <p>&nbsp;&nbsp;Detalle de cabecera</p>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div
                      class="col-md-12"
                      style="font-size: 10px; min-height: 50px"
                    >
                      <table
                        v-if="codigoPromocion"
                        style="text-align: left; font-size: 12px; border: 1"
                        cellpadding="0"
                        cellspacing="0"
                        class="table table-sm table-hover"
                      >
                        <tbody>
                          <tr>
                            <th
                              class="text-end"
                              scope="row"
                              style="width: 10rem"
                            >
                              Código:
                            </th>
                            <td
                              v-text="codigoPromocion"
                              style="width: 25px"
                            ></td>
                            <th
                              class="text-end"
                              scope="row"
                              style="width: 50px"
                            >
                              Fecha&nbsp;inicio:
                            </th>
                            <td style="width: 15rem" v-text="fechaInicio"></td>
                            <th
                              class="text-end"
                              scope="row"
                              style="width: 15rem"
                            >
                              Fecha fin:&nbsp;&nbsp;&nbsp;
                            </th>
                            <td style="width: 15rem" v-text="fechaFin"></td>
                            <th
                              class="text-end"
                              scope="row"
                              style="width: 10rem"
                            >
                              Estado:&nbsp;&nbsp;&nbsp;
                            </th>
                            <td
                              v-if="estadoPromocion == 'Pendiente'"
                              v-text="estadoPromocion"
                              style="background-color: #8fe88a"
                            ></td>
                            <td
                              v-if="estadoPromocion == 'Activo'"
                              v-text="estadoPromocion"
                              style="background-color: #8fe88a"
                            ></td>
                            <td
                              v-if="estadoPromocion == 'Finalizado'"
                              v-text="estadoPromocion"
                              style="background-color: #f96443"
                            ></td>
                          </tr>
                          <tr>
                            <th class="text-end" scope="row">Nombre:</th>
                            <td colspan="7" v-text="nombrePromocion"></td>
                          </tr>
                          <tr>
                            <th class="text-end" scope="row">Descripción:</th>
                            <td colspan="7">
                              <p>{{ observacionesPromocion }}</p>
                            </td>
                          </tr>

                          <tr class="align-middle">
                            <th class="text-end CellWithComment" scope="row">
                              Descripción&nbsp;<br />mecánica:&nbsp;<i
                                class="fas fa-question-circle"
                              ></i>
                              <!--<span class="text-start CellComment" style="font-weight:normal;">-->

                              <div
                                class="card text-start CellComment"
                                id="span1"
                              >
                                <div class="card-header" style="top: -15px">
                                  Descripción&nbsp;mecánica
                                </div>
                                <div
                                  class="men-tooltip card-body text-start lh-sm"
                                  style="
                                    top: -5px;
                                    min-height: 25px;
                                    max-height: 150px;
                                  "
                                >
                                  <p>
                                    Indica la relación que existe entre la
                                    acumulación y la cantidad de producto a
                                    recibir como beneficio.
                                  </p>
                                </div>
                              </div>

                              <!--
                              -&nbsp;Descripción&nbsp;mecánica<br>
                              </span> -->
                            </th>
                            <td
                              v-text="mecanica"
                              style="
                                width: 30rem;
                                border: 1.25px;
                                border-style: ridge;
                              "
                            ></td>
                            <th
                              class="text-end CellWithComment"
                              scope="row"
                              style="width: 15rem"
                            >
                              Modalidad:&nbsp;<i
                                class="fas fa-question-circle"
                              ></i>

                              <div
                                class="card text-start CellComment"
                                id="span1"
                              >
                                <div class="card-header" style="top: -15px">
                                  Modalidad
                                </div>
                                <div
                                  class="men-tooltip card-body text-start lh-sm"
                                  style="
                                    top: -5px;
                                    min-height: 25px;
                                    max-height: 150px;
                                  "
                                >
                                  <p class="card-text">
                                    Tipo de clasificación de la promoción.
                                  </p>
                                </div>
                              </div>
                            </th>
                            <td
                              v-text="tipoMF"
                              style="
                                background-color: #ebeef6;
                                border: 1.25px;
                                border-style: ridge;
                              "
                              colspan="2"
                            ></td>

                            <th
                              class="text-end CellWithComment"
                              scope="row"
                              style="width: 8rem"
                            >
                              Tipo acumulación:&nbsp;<i
                                class="fas fa-question-circle"
                              ></i>
                              <div
                                class="card text-start CellComment"
                                id="span1"
                              >
                                <div class="card-header" style="top: -15px">
                                  Tipo acumulación
                                </div>
                                <div
                                  class="men-tooltip card-body text-start lh-sm"
                                  style="
                                    top: -5px;
                                    min-height: 25px;
                                    max-height: 250px;
                                  "
                                >
                                  <p class="card-text">
                                    Tipo de comportamiento de la promoción.
                                  </p>
                                  <p class="card-text">
                                    Acumulable: El cliente por comprar el
                                    producto acumula hasta cumplir condición.
                                  </p>
                                  <p class="card-text">
                                    No Acumulable: El cliente debe comprar la
                                    cantidad necesaria para cumplir condición en
                                    una sola factura.
                                  </p>
                                </div>
                              </div>
                            </th>
                            <td
                              style="
                                background-color: #ebeef6;
                                border: 1.25px;
                                border-style: ridge;
                              "
                              colspan="2"
                              v-text="tipoAcumulacion"
                            ></td>
                          </tr>

                          <tr class="align-middle">
                            <th class="text-end CellWithComment" scope="row">
                              Inicio de&nbsp;<br />acumulación:&nbsp;<i
                                class="fas fa-question-circle"
                              ></i>
                              <div
                                class="card text-start CellComment"
                                id="span1"
                              >
                                <div class="card-header" style="top: -15px">
                                  Inicio de acumulación
                                </div>
                                <div
                                  class="men-tooltip card-body text-start lh-sm"
                                  style="
                                    top: -5px;
                                    min-height: 25px;
                                    max-height: 200px;
                                  "
                                >
                                  <p class="card-text">
                                    Fecha, hora y minutos desde cuando va a
                                    comenzar a tener acumulaciones de productos
                                    según la condición. Esta fecha se controla
                                    con la configuración de “Pendiente canje”.
                                  </p>
                                </div>
                              </div>
                            </th>
                            <td
                              style="
                                background-color: #139ab8;
                                color: #ffffff;
                                border: 1.5px;
                                border-style: ridge;
                                width: 10rem;
                              "
                              v-text="fechaInicioAcumulacion"
                            ></td>
                            <th class="text-end CellWithComment" scope="row">
                              Período de<br />canje:&nbsp;<i
                                class="fas fa-question-circle"
                              ></i>
                              <div
                                class="card text-start CellComment"
                                id="span1"
                              >
                                <div class="card-header" style="top: -15px">
                                  Período de canje
                                </div>
                                <div
                                  class="men-tooltip card-body text-start lh-sm"
                                  style="
                                    top: -5px;
                                    min-height: 25px;
                                    max-height: 150px;
                                  "
                                >
                                  <p class="card-text">
                                    Número de meses con los cuales la promoción
                                    se puede reiniciar los limites de aplicación
                                    de la promoción.
                                  </p>
                                </div>
                              </div>
                            </th>
                            <td
                              style="
                                background-color: #139ab8;
                                color: #ffffff;
                                border: 1.5px;
                                border-style: ridge;
                              "
                              colspan="2"
                            >
                              {{ periodoCanje }}&nbsp;{{ unidadPeriodoCanje }}
                            </td>
                            <th
                              class="text-end CellWithComment"
                              scope="row"
                              style="width: 10rem"
                              v-if="tipoMF != 'Tratamiento Completo'"
                            >
                              Pendiente canje:&nbsp;<i
                                class="fas fa-question-circle"
                              ></i>
                              <div
                                class="card text-start CellComment"
                                id="span1"
                              >
                                <div class="card-header" style="top: -15px">
                                  Pendiente canje
                                </div>
                                <div
                                  class="men-tooltip card-body text-start lh-sm"
                                  style="
                                    top: -5px;
                                    min-height: 25px;
                                    max-height: 150px;
                                  "
                                >
                                  <p class="card-text">
                                    Número de meses a partir de la fecha actual
                                    hacia atrás para poder considerar las
                                    unidades acumuladas y poder determinar si
                                    aplica la entrega del beneficio.
                                  </p>
                                </div>
                              </div>
                            </th>
                            <td
                              v-if="tipoMF != 'Tratamiento Completo'"
                              style="
                                background-color: #139ab8;
                                color: #ffffff;
                                border: 1.5px;
                                border-style: ridge;
                              "
                              colspan="2"
                            >
                              {{ mesPendienteCanje }}&nbsp;{{
                                unidadPeriodoCanje
                              }}
                            </td>
                          </tr>
                          <tr>
                            <th class="text-end" scope="row">Responsable:</th>
                            <td
                              v-text="responsablePromo"
                              style="width: 15rem"
                            ></td>
                            <th
                              class="text-end"
                              scope="row"
                              colspan="2"
                              style="width: 10rem"
                            >
                              Línea Comercial&nbsp;Solicitante:
                            </th>
                            <td
                              v-text="lineaCSolicitante"
                              style="width: 15rem"
                              colspan="4"
                            ></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!--<div class="col-md-5 invisible">
                      <div>
                        <table
                          v-if="codigoPromocion"
                          style="text-align: left; font-size: 12px"
                          cellpadding="0"
                          cellspacing="0"
                          class="border border-secondary"
                        >
                          <tbody>
                            <tr>
                              <td
                                colspan="4"
                                scope="row"
                                style="background: #ebeef6"
                                class="border border-secondary text-center card-header fw-bold text-black"
                              >
                                Datos de Responsable
                              </td>
                            </tr>
                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Responsable:&nbsp;&nbsp;&nbsp;
                              </th>
                              <td
                                colspan="2"
                                v-text="responsablePromo"
                                style="width: 15rem"
                              ></td>
                            </tr>
                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Línea Com.&nbsp;Solicitante:&nbsp;&nbsp;&nbsp;
                              </th>
                              <td colspan="2" v-text="lineaCSolicitante"></td>
                            </tr>

                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Genera Cobro:&nbsp;&nbsp;&nbsp;
                              </th>
                              <td colspan="2" v-text="generaCobro"></td>
                            </tr>
                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Asume Categoría:&nbsp;&nbsp;&nbsp;
                              </th>
                              <td colspan="2" v-text="asumeCategoria"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <br />
                      <div>
                        <table
                          v-if="codigoPromocion"
                          style="text-align: left; font-size: 12px"
                          cellpadding="0"
                          cellspacing="0"
                          class="border border-secondary"
                        >
                          <tbody>
                            <tr>
                              <td
                                colspan="4"
                                scope="row"
                                style="background: #139ab8"
                                class="border border-secondary text-center card-header fw-bold text-white"
                              >
                                Datos de Usuario
                              </td>
                            </tr>
                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Usuario (crea):&nbsp;&nbsp;&nbsp;
                              </th>
                              <td
                                colspan="2"
                                style="width: 15rem"
                                v-text="usuario"
                              ></td>
                            </tr>
                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Fecha de registro:&nbsp;&nbsp;&nbsp;
                              </th>
                              <td colspan="2" v-text="fechaRegistro"></td>
                            </tr>
                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Usuario (último cambio):&nbsp;&nbsp;&nbsp;
                              </th>
                              <td colspan="2" v-text="usuarioModifica"></td>
                            </tr>
                            <tr>
                              <th
                                class="text-end"
                                scope="row"
                                style="width: 10rem"
                              >
                                Fecha (último cambio):&nbsp;&nbsp;&nbsp;
                              </th>
                              <td colspan="2" v-text="fechaUltimoCambio"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Fin Mostrar encabezado promocion -->
            <!-- condiciones simples -->

            <!--condiciones-->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Condiciones
                      </button>
                    </h1>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div
                        class="accordion-body"
                        style="font-size: 11px; height: 375px"
                      >
                        <!--
                      <div class="table-responsive col-md-6" v-for="(aBen,index) in arrayBeneficiosProcess" :key="index">
                       <table class="table table-bordered table-striped table-sm">
                              <tr>
                                <th>Código</th>
                                <th>Descripción</th>
                                <th>Estado</th>
                              </tr>
                              <tr v-for="(cond,indexx) in aBen.cod" :key="indexx">
                                <td>{{cond.codigoProducto}}</td>
                                <td>{{cond.descripcionProducto}}</td>
                                <td>{{cond.status}}</td>
                              </tr>
                              
                            </table> 
                      </div>
                      -->
                        <div class="row">
                          <!---->
                          <!--
                          <div class="col-md-5 invisible">
                            <div class="input-group" style="font-size: 13px">
                              <label class="fw-bold"
                                >Buscar:&nbsp;&nbsp;&nbsp;</label
                              ><input
                                type="text"
                                v-model="buscarCondicionesLk"
                                class="form-control-sm form-control col-md-2"
                                placeholder="Buscar condiciones"
                                style="font-size: 12px"
                                @keyup.enter="buscarCondicionesLike()"
                              />
                            </div>
                          </div>
                        -->
                          <!---->
                          <div class="col-md-5">
                            <div>
                              <div style="font-size: 12px" class="text-start">
                                <label class="fw-bold"
                                  >&nbsp;&nbsp;Buscar&nbsp;opciones:</label
                                >
                                <!--
                                  &nbsp;Código&nbsp;
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="selectCodDesC"
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span> </label
                                >&nbsp;Nombre
                                -->
                              </div>
                            </div>
                            <div class="input-group" style="font-size: 12px">
                              <label class="fw-bold">&nbsp;</label>
                              <input
                                v-if="selectCodDesC == 0"
                                type="text"
                                v-model="buscarCondicionesLk"
                                class="form-control-sm form-control col-md-3"
                                placeholder="Código o nombre de producto"
                                style="font-size: 12px"
                                @keyup.enter="buscarCondicionesLike()"
                              />
                              <input
                                v-else
                                type="text"
                                v-model="buscarCondicionesLk"
                                class="form-control-sm form-control col-md-3"
                                placeholder="Nombre de producto"
                                style="font-size: 12px"
                                @keyup.enter="buscarCondicionesLike()"
                              />
                            </div>
                          </div>
                          <!---->

                          <div class="text-end col-md-1" style="height: 5px">
                            <table
                              class="table-sm text-end"
                              style="font-size: 11px; width: 30px"
                            >
                              <tr>
                                <th class="text-end CellWithComment1">
                                  &nbsp;&nbsp;<i
                                    class="fas fa-question-circle"
                                    style="font-size: 13px"
                                  ></i>
                                  <div
                                    class="card text-start CellComment1"
                                    id="span2"
                                  >
                                    <div
                                      class="card-header fw-bold"
                                      style="font-size: 12px; top: -15px"
                                    >
                                      Condiciones
                                    </div>
                                    <div
                                      class="men-tooltip card-body text-start lh-sm"
                                      style="
                                        top: -5px;
                                        min-height: 25px;
                                        max-height: 200px;
                                      "
                                    >
                                      <p class="card-text">
                                        Buscador de productos: Filtro por nombre
                                        de producto que son parte de las
                                        condiciones.
                                      </p>
                                      <p class="card-text">
                                        <i
                                          class="far fa-square"
                                          style="background: #80d1e7"
                                        ></i
                                        >&nbsp;Valor que puede acumular entre
                                        todos los productos participantes.
                                      </p>
                                      <p class="card-text">
                                        <i
                                          class="far fa-square"
                                          style="background: #8fe88a"
                                        ></i
                                        >&nbsp;Valor que puede acumular de
                                        manera individual por cada producto
                                        participante.
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                            </table>
                          </div>
                          <div class="col-md-5" style="font-size: 14px">
                            <div @click="verConfiguracion()">
                              <i class="fa fa-bars" aria-hidden="true"></i
                              >&nbsp;Ver Configuración
                            </div>
                          </div>
                          <div
                            class="col-md-1 text-end"
                            style="font-size: 11px"
                          >
                            <table class="table-sm">
                              <tr>
                                <td class="text-end CellWithComment1">
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                                    class="fas fa-question-circle"
                                    style="font-size: 14px"
                                  ></i>
                                  <div
                                    class="card text-start CellComment1"
                                    id="span2"
                                  >
                                    <div
                                      class="card-header fw-bold"
                                      style="font-size: 12px; top: -15px"
                                    >
                                      Configuración
                                    </div>
                                    <div
                                      class="men-tooltip card-body text-start lh-sm"
                                      style="
                                        top: -5px;
                                        min-height: 25px;
                                        max-height: 150px;
                                      "
                                    >
                                      <p class="card-text">
                                        Detalle de la configuración de la
                                        promoción con los operadores lógicos
                                        Y/O.
                                      </p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <br />
                        <!-- -->
                        <div class="row">
                          <div class="col-md-7">
                            <div
                              style="
                                font-size: 10px;
                                min-height: 50px;
                                max-height: 150px;
                                overflow-y: scroll;
                                border: 1.5px;
                                border-style: ridge;
                              "
                            >
                              <div
                                class="table-responsive"
                                v-for="(aBen, index) in arrayCondicionesProcess"
                                :key="index"
                              >
                                <div class="text-start fw-bold">
                                  <labal style="font-size: 12px"
                                    >Opción {{ index + 1 }}:</labal
                                  >
                                </div>

                                <table
                                  class="table table-bordered table-striped table-sm tab-head"
                                  style="font-size: 10px; border: 0.5px"
                                >
                                  <thead class="table-light">
                                    <tr class="tab-cabecere">
                                      <th>Código</th>
                                      <th>Descripción</th>
                                      <th class="text-end">Cant.&nbsp;Req.</th>
                                      <th>Acum.Cajas</th>
                                      <th>Estado</th>
                                    </tr>
                                  </thead>
                                  <tr
                                    v-for="(cond, indexx) in aBen.cod"
                                    :key="indexx"
                                    style="border: 0.5px"
                                  >
                                    <td class="text-start">
                                      {{ cond.codigoProducto }}
                                    </td>
                                    <td class="text-start">
                                      {{ cond.descripcionProducto }}
                                    </td>
                                    <td
                                      v-if="cond.tipoAC == '0'"
                                      style="background: #80d1e7"
                                    >
                                      {{ cond.cantidad }}
                                    </td>
                                    <td v-else style="background: #8fe88a">
                                      {{ cond.cantidad }}
                                    </td>
                                    <td v-if="cond.acumulacionCajas == true">
                                      SI
                                    </td>
                                    <td v-if="cond.acumulacionCajas == false">
                                      NO
                                    </td>
                                    <td>{{ cond.status }}</td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            <div class="row"></div>
                            <div class="fw-bold text-start">
                              <h7 style="font-size: 12px">
                                Sucursales participantes en la promoción:
                              </h7>
                            </div>
                            <div
                              class="table-responsive"
                              style="
                                font-size: 10px;
                                min-height: 50px;
                                max-height: 150px;
                                overflow-y: scroll;
                                border: 1.5px;
                                border-style: ridge;
                              "
                            >
                              <table
                                class="table table-bordered table-sm tab-head"
                              >
                                <thead class="table-light">
                                  <tr class="tab-cabecere">
                                    <th>Código</th>
                                    <th>Sucursal</th>
                                    <th>Oficinas</th>
                                  </tr>
                                </thead>
                                <tr
                                  v-for="(
                                    cond, index
                                  ) in arraySucursalesProcess"
                                  :key="index"
                                  style="border: 0.5px"
                                >
                                  <td v-if="cond.Oficinas != 0">
                                    {{ cond.Codigo }}
                                  </td>
                                  <td
                                    v-if="cond.Oficinas != 0"
                                    class="text-start"
                                  >
                                    {{ cond.Sucursal }}
                                  </td>
                                  <td v-if="cond.Oficinas != 0">
                                    {{ cond.Oficinas }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                          <div
                            class="table-responsive col-md-5"
                            v-if="statusConfig == 1"
                          >
                            <!--arbol-->
                            <div
                              class="table-responsive"
                              style="
                                font-size: 11px;
                                min-height: 100px;
                                max-height: 250px;
                                overflow-y: scroll;
                              "
                            >
                              <ul style="text-align: left">
                                <li
                                  class="list-group-item"
                                  v-for="(item, indexx) in arrayItem"
                                  :key="indexx"
                                >
                                  <label
                                    class="fw-bold text-white"
                                    v-if="padreSeleccionado == indexx"
                                    style="background: #06758E; text-white"
                                    @click="
                                      seleccionarPadre(item.codigoGrupo, indexx)
                                    "
                                    >&nbsp;{{ item.nombreGrupo }}&nbsp;</label
                                  >&nbsp;&nbsp;
                                  <label
                                    class="fw-bold"
                                    v-else
                                    style="background: none"
                                    @click="
                                      seleccionarPadre(item.codigoGrupo, indexx)
                                    "
                                    >{{ item.nombreGrupo }}</label
                                  >&nbsp;&nbsp;
                                  <label
                                    v-if="estado_proceso === 1"
                                    class="col-md-1"
                                    @click="
                                      eliminarPadre(indexx, item.codigoGrupo)
                                    "
                                    ><i class="far fa-trash-alt"></i
                                  ></label>

                                  <ul>
                                    <li
                                      v-for="(it, index) in item.condiciones"
                                      :key="index"
                                      style="
                                        list-style: none;
                                        list-style-position: inside;
                                      "
                                    >
                                      <div v-if="it.operador === 'AND'">
                                        <ul>
                                          <li
                                            v-if="
                                              it.tipo == 'productos' ||
                                              it.tipo == 'productoscombinados'
                                            "
                                            style="
                                              list-style: none;
                                              list-style-position: inside;
                                            "
                                          >
                                            <label
                                              @click="
                                                seleccionarHijo(
                                                  index,
                                                  it.idHijo,
                                                  it.tipo
                                                )
                                              "
                                            >
                                              <i class="fas fa-dot-circle"></i
                                              >&nbsp;{{
                                                it.mensajeCondicion
                                              }}
                                              &nbsp;productos&nbsp;:&nbsp;</label
                                            >
                                            <label
                                              v-if="
                                                it.codigoProducto.toString()
                                                  .length > 50
                                              "
                                              style="width: 90%"
                                            >
                                              {{
                                                it.codigoProducto
                                                  .toString()
                                                  .substring(0, 110) + "......."
                                              }}
                                              <a
                                                @click="
                                                  verProdCod(
                                                    it.codigoProducto.toString(),
                                                    0
                                                  )
                                                "
                                                ><i
                                                  class="fas fa-plus-square"
                                                ></i
                                              ></a>
                                            </label>
                                            <label v-else>
                                              {{
                                                it.codigoProducto.toString()
                                              }}</label
                                            >

                                            <div>
                                              Cant.:{{ it.cantidad }}

                                              <!--<div>-->
                                              <!-- productos -->
                                              &nbsp;&nbsp;&nbsp;Relación&nbsp;acumulación:&nbsp;<label
                                                v-if="it.relacion == 1"
                                                >Individual.</label
                                              ><label v-else
                                                >Entre todos.</label
                                              >
                                              &nbsp;&nbsp;<label
                                                v-if="it.acumulacionCajas"
                                                >Acumula cajas.</label
                                              >
                                              &nbsp;&nbsp;<label
                                                v-if="it.acumulable"
                                                >Es acumulable.</label
                                              >
                                              <!--</div>-->
                                              <!-- menu menu de condi -->
                                              <div
                                                v-if="
                                                  estado_proceso === 1 &&
                                                  padreSeleccionado === indexx
                                                "
                                                class="btn-group dropend"
                                              >
                                                <button
                                                  class="btn btn-sm btn-sm"
                                                  style="font-size: 11px"
                                                  type="button"
                                                >
                                                  <i class="fas fa-tools"></i>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                                  data-bs-toggle="dropdown"
                                                  aria-expanded="false"
                                                >
                                                  <span class="visually-hidden"
                                                    >Toggle Dropdown</span
                                                  >
                                                </button>
                                                <ul class="dropdown-menu">
                                                  <li>
                                                    <a
                                                      class="dropdown-item"
                                                      style="font-size: 12px"
                                                      @click="
                                                        abrirModalCondicionesProdEdit(
                                                          index,
                                                          it.idHijo,
                                                          it.idPadre,
                                                          it
                                                        )
                                                      "
                                                      ><i
                                                        class="fas fa-pencil-alt"
                                                      ></i
                                                      >&nbsp;Editar</a
                                                    >
                                                  </li>
                                                  <li>
                                                    <a
                                                      class="dropdown-item"
                                                      style="font-size: 12px"
                                                      @click="
                                                        eliminarHijo(
                                                          index,
                                                          it.idHijo,
                                                          it.idPadre
                                                        )
                                                      "
                                                      ><i class="fas fa-ban"></i
                                                      >&nbsp;Eliminar</a
                                                    >
                                                  </li>
                                                </ul>
                                              </div>
                                              <!-- fin menu menu cond -->
                                            </div>
                                          </li>
                                          <li v-else style="list-style: none">
                                            <label
                                              @click="
                                                seleccionarHijo(
                                                  index,
                                                  it.idHijo,
                                                  it.tipo
                                                )
                                              "
                                              ><i class="fas fa-dot-circle"></i
                                              >&nbsp;{{ it.mensajeCondicion
                                              }}{{ it.tipo }}:{{ it.sucursal
                                              }}{{ it.region }}{{ it.provincia
                                              }}{{ it.ciudad }}{{ it.oficina
                                              }}{{ it.segmento }}</label
                                            >:

                                            <!-- menu menu de condi -->
                                            <div
                                              v-if="
                                                estado_proceso === 1 &&
                                                padreSeleccionado === indexx
                                              "
                                              class="btn-group dropend"
                                            >
                                              <button
                                                class="btn btn-sm btn-sm"
                                                style="font-size: 11px"
                                                type="button"
                                              >
                                                <i class="fas fa-tools"></i>
                                              </button>
                                              <button
                                                type="button"
                                                class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                              >
                                                <span class="visually-hidden"
                                                  >Toggle Dropdown</span
                                                >
                                              </button>
                                              <ul class="dropdown-menu">
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      abrirModalProvLabSecCondicionEdit(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre,
                                                        it
                                                      )
                                                    "
                                                    ><i
                                                      class="fas fa-pencil-alt"
                                                    ></i
                                                    >&nbsp;Editar</a
                                                  >
                                                </li>
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      eliminarHijo(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre
                                                      )
                                                    "
                                                    ><i class="fas fa-ban"></i
                                                    >&nbsp;Eliminar</a
                                                  >
                                                </li>
                                              </ul>
                                            </div>
                                            <!-- fin menu menu cond -->
                                            <div>
                                              &nbsp;&nbsp;&nbsp;Aplica&nbsp;para:&nbsp;<label
                                                v-if="it.condicionAcumulacion"
                                                >Acumulación</label
                                              >&nbsp;&nbsp;<label
                                                v-if="it.condicionCanje"
                                                >-&nbsp;Canje</label
                                              >
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                      <div v-else>
                                        <div
                                          v-if="
                                            it.tipo == 'productos' ||
                                            it.tipo == 'productoscombinados'
                                          "
                                        >
                                          <label
                                            @click="
                                              seleccionarHijo(
                                                index,
                                                it.idHijo,
                                                it.tipo
                                              )
                                            "
                                            ><i
                                              class="fas fa-arrow-circle-right"
                                            ></i
                                            >&nbsp;{{
                                              it.mensajeCondicion
                                            }}
                                            &nbsp;productos&nbsp;:</label
                                          >
                                          <label
                                            v-if="
                                              it.codigoProducto.toString()
                                                .length > 50
                                            "
                                            style="width: 90%"
                                          >
                                            {{
                                              it.codigoProducto
                                                .toString()
                                                .substring(0, 110) + "......."
                                            }}
                                            <a
                                              @click="
                                                verProdCod(
                                                  it.codigoProducto.toString(),
                                                  0
                                                )
                                              "
                                              ><i class="fas fa-plus-square"></i
                                            ></a>
                                          </label>
                                          <label v-else>
                                            {{
                                              it.codigoProducto.toString()
                                            }}</label
                                          >

                                          <div>
                                            Cant.:{{ it.cantidad }}
                                            <!--<div> -->
                                            <!-- productos -->
                                            &nbsp;&nbsp;&nbsp;Relación&nbsp;acumulación:&nbsp;<label
                                              v-if="it.relacion == 1"
                                              >Individual.</label
                                            ><label v-else>Entre todos.</label>
                                            &nbsp;&nbsp;<label
                                              v-if="it.acumulacionCajas"
                                              >Acumula cajas.</label
                                            >
                                            &nbsp;&nbsp;<label
                                              v-if="it.acumulable"
                                              >Es acumulable.</label
                                            >
                                            <!--</div>-->
                                            <!-- menu menu de condi -->
                                            <div
                                              v-if="
                                                estado_proceso === 1 &&
                                                padreSeleccionado === indexx
                                              "
                                              class="btn-group dropend"
                                            >
                                              <button
                                                class="btn btn-sm btn-sm"
                                                style="font-size: 11px"
                                                type="button"
                                              >
                                                <i class="fas fa-tools"></i>
                                              </button>
                                              <button
                                                type="button"
                                                class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                              >
                                                <span class="visually-hidden"
                                                  >Toggle Dropdown</span
                                                >
                                              </button>
                                              <ul class="dropdown-menu">
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      abrirModalCondicionesProdEdit(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre,
                                                        it
                                                      )
                                                    "
                                                    ><i
                                                      class="fas fa-pencil-alt"
                                                    ></i
                                                    >&nbsp;Editar</a
                                                  >
                                                </li>
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      eliminarHijo(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre
                                                      )
                                                    "
                                                    ><i class="fas fa-ban"></i
                                                    >&nbsp;Eliminar</a
                                                  >
                                                </li>
                                              </ul>
                                            </div>
                                            <!-- fin menu menu cond -->
                                          </div>
                                        </div>
                                        <div v-else>
                                          <label
                                            @click="
                                              seleccionarHijo(
                                                index,
                                                it.idHijo,
                                                it.tipo
                                              )
                                            "
                                            ><i
                                              class="fas fa-arrow-circle-right"
                                            ></i
                                            >&nbsp;{{ it.mensajeCondicion
                                            }}{{ it.tipo }}:{{ it.sucursal
                                            }}{{ it.region }}{{ it.provincia
                                            }}{{ it.ciudad }}{{ it.oficina
                                            }}{{ it.segmento }}</label
                                          >:

                                          <!-- menu menu de condi -->
                                          <div
                                            v-if="
                                              estado_proceso === 1 &&
                                              padreSeleccionado === indexx
                                            "
                                            class="btn-group dropend"
                                          >
                                            <button
                                              class="btn btn-sm btn-sm"
                                              style="font-size: 11px"
                                              type="button"
                                            >
                                              <i class="fas fa-tools"></i>
                                            </button>
                                            <button
                                              type="button"
                                              class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                              <span class="visually-hidden"
                                                >Toggle Dropdown</span
                                              >
                                            </button>
                                            <ul class="dropdown-menu">
                                              <li>
                                                <a
                                                  class="dropdown-item"
                                                  style="font-size: 12px"
                                                  @click="
                                                    abrirModalProvLabSecCondicionEdit(
                                                      index,
                                                      it.idHijo,
                                                      it.idPadre,
                                                      it
                                                    )
                                                  "
                                                  ><i
                                                    class="fas fa-pencil-alt"
                                                  ></i
                                                  >&nbsp;Editar</a
                                                >
                                              </li>
                                              <li>
                                                <a
                                                  class="dropdown-item"
                                                  style="font-size: 12px"
                                                  @click="
                                                    eliminarHijo(
                                                      index,
                                                      it.idHijo,
                                                      it.idPadre
                                                    )
                                                  "
                                                  ><i class="fas fa-ban"></i
                                                  >&nbsp;Eliminar</a
                                                >
                                              </li>
                                            </ul>
                                          </div>
                                          <!-- fin menu menu cond -->
                                          <div>
                                            &nbsp;&nbsp;&nbsp;Aplica&nbsp;para:&nbsp;<label
                                              v-if="it.condicionAcumulacion"
                                              >Acumulación</label
                                            >&nbsp;&nbsp;<label
                                              v-if="it.condicionCanje"
                                              >-&nbsp;Canje</label
                                            >
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </div>

                            <!--arbol-->
                          </div>
                        </div>
                      </div>
                      <!---->

                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--fin condiciones-->
            <!-- fin condiciones simples -->

            <!--Grupos de  Beneficios -->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample1">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne1">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne1"
                        aria-expanded="true"
                        aria-controls="collapseOne1"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Beneficios
                      </button>
                    </h1>
                    <div
                      id="collapseOne1"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne1"
                      data-bs-parent="#accordionExample1"
                    >
                      <div
                        class="accordion-body"
                        style="
                          font-size: 11px;
                          min-height: 200px;
                          max-height: 350px;
                          overflow-y: scroll;
                        "
                      >
                        <!--
                        <div class="col-md-5">
                          <div class="input-group" style="font-size: 12px">
                            <label class="fw-bold"
                              >Buscar:&nbsp;&nbsp;&nbsp;</label
                            ><input
                              type="text"
                              v-model="buscarBeneficiosLk"
                              class="form-control-sm form-control col-md-2"
                              placeholder="Buscar beneficios"
                              style="font-size: 12px"
                              @keyup.enter="buscarBeneficiosLike()"
                            />
                          </div>
                        </div>
                      -->

                        <!---->
                        <div class="col-md-5">
                          <div>
                            <div style="font-size: 12px" class="text-start">
                              <label class="fw-bold"
                                >&nbsp;&nbsp;Buscar&nbsp;opciones:</label
                              >
                              <!--
                              &nbsp;Código&nbsp;
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-model="selectCodDesB"
                                  true-value="1"
                                  false-value="0"
                                />
                                <span class="slider round"></span> </label
                              >&nbsp;Nombre
                              -->
                            </div>
                          </div>
                          <div class="input-group" style="font-size: 12px">
                            <label class="fw-bold">&nbsp;</label>
                            <input
                              v-if="selectCodDesB == 0"
                              type="text"
                              v-model="buscarBeneficiosLk"
                              class="form-control-sm form-control col-md-3"
                              placeholder="Código o nombre de producto"
                              style="font-size: 12px"
                              @keyup.enter="buscarBeneficiosLike()"
                            />
                            <input
                              v-else
                              type="text"
                              v-model="buscarBeneficiosLk"
                              class="form-control-sm form-control col-md-3"
                              placeholder="Nombre de producto"
                              style="font-size: 12px"
                              @keyup.enter="buscarBeneficiosLike()"
                            />
                          </div>
                        </div>
                        <!---->

                        <br />
                        <div
                          class="table-responsive col-md-6"
                          v-for="(aCond, index) in arrayBeneficiosProcess"
                          :key="index"
                          style="
                            font-size: 10px;
                            min-height: 50px;
                            max-height: 150px;
                            overflow-y: scroll;
                            border: 1.5px;
                            border-style: ridge;
                          "
                        >
                          <div class="fw-bold text-start">
                            <label style="font-size: 11px"
                              >Opción {{ index + 1 }}:</label
                            >
                          </div>
                          <table
                            class="table table-bordered table-striped table-sm tab-head"
                            style="font-size: 10px"
                          >
                            <thead class="table-light">
                              <tr class="tab-cabecere">
                                <th>Código</th>
                                <th>Descripción</th>
                                <th>Cant.<br />Canje</th>
                                <th>Límite&nbsp;Aplicación<br/>(Promoción)</th>
                                <th>Límite&nbsp;Canje<br/>(Cliente)</th>
                                <th>Estado</th>
                              </tr>
                            </thead>
                            <tr
                              v-for="ben in aCond.beneficios"
                              style="border: 0.5px"
                            >
                              <td class="text-start">
                                {{ ben.codigoProducto }}
                              </td>
                              <td class="text-start">
                                {{ ben.detalleProducto }}
                              </td>
                              <td>{{ ben.cantidad }}</td>
                              <td v-if="ben.limiteAplicacion == 0">
                                Ilimitado
                              </td>
                              <td v-else>{{ ben.limiteAplicacion }}</td>
                              <td v-if="ben.limiteCanje == 0">
                                Ilimitado
                              </td>
                              <td v-else>{{ ben.limiteCanje }}</td>
                              <td>{{ ben.status }}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fin Grupos de  Beneficios -->

            <!--Oficinas participantes -->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample2">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne2">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne2"
                        aria-expanded="true"
                        aria-controls="collapseOne2"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Oficinas participantes
                      </button>
                    </h1>
                    <div
                      id="collapseOne2"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne2"
                      data-bs-parent="#accordionExample2"
                    >
                      <div
                        class="accordion-body"
                        style="font-size: 11px; height: 350px"
                      >
                        <!--
                        <div class="col-md-5">
                          <div class="input-group" style="font-size: 12px">
                            <label class="fw-bold"
                              >Buscar:&nbsp;&nbsp;&nbsp;</label
                            ><input
                              type="text"
                              v-model="buscarOficinaLk"
                              class="form-control-sm form-control col-md-2"
                              placeholder="Buscar oficina"
                              style="font-size: 12px"
                              @keyup.enter="buscarOficinaLike()"
                            />
                          </div>
                        </div>
                      -->
                        <!---->
                        <div class="col-md-5">
                          <div>
                            <div style="font-size: 12px" class="text-start">
                              <label class="fw-bold"
                                >&nbsp;&nbsp;Buscar&nbsp;Oficinas:</label
                              >
                              <!--
                                &nbsp;Código&nbsp;
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-model="selectCodDesO"
                                  true-value="1"
                                  false-value="0"
                                />
                                <span class="slider round"></span> </label
                              >&nbsp;Nombre
                              -->
                            </div>
                          </div>
                          <div class="input-group" style="font-size: 12px">
                            <label class="fw-bold">&nbsp;</label>
                            <input
                              v-if="selectCodDesO == 0"
                              type="text"
                              v-model="buscarOficinaLk"
                              class="form-control-sm form-control col-md-3"
                              placeholder="Código o nombre de oficina"
                              style="font-size: 12px"
                              @keyup.enter="buscarOficinaLike()"
                            />
                            <input
                              v-else
                              type="text"
                              v-model="buscarOficinaLk"
                              class="form-control-sm form-control col-md-3"
                              placeholder="Nombre de oficina"
                              style="font-size: 12px"
                              @keyup.enter="buscarOficinaLike()"
                            />
                          </div>
                        </div>
                        <!---->
                        <br />

                        <div
                          class="col-md-9"
                          style="
                            overflow-y: scroll;
                            font-size: 10px;
                            min-height: 150px;
                            max-height: 275px;
                            overflow-y: scroll;
                            border: 1.5px;
                            border-style: ridge;
                          "
                        >
                          <table
                            class="table table-bordered table-striped table-sm tab-head"
                          >
                            <thead class="table-light">
                              <tr class="tab-cabecere">
                                <th>Nro</th>
                                <th>Sucursal</th>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Provincia</th>
                                <th>Ciudad</th>
                                <th>Acumulación</th>
                                <th>&nbsp;&nbsp;Canje</th>
                              </tr>
                            </thead>
                            <tr
                              v-for="(ofi, index) in arrayOficinasProcess"
                              :key="index"
                              style="border: 0.5px"
                            >
                              <td>{{ index + 1 }}&nbsp;</td>
                              <td class="text-start">
                                {{ ofi.nombre_sucursal }}
                              </td>
                              <td>{{ ofi._id }}</td>
                              <td class="text-start">
                                {{ ofi.nombre_oficina }}
                              </td>
                              <td class="text-start">
                                {{ ofi.nombre_provincia }}
                              </td>
                              <td class="text-start">
                                &nbsp;&nbsp;{{ ofi.nombre_ciudad }}
                              </td>
                              <td v-if="ofi.Acumulacion">SI</td>
                              <td v-else>NO</td>
                              <td v-if="ofi.Canje">SI</td>
                              <td v-else>NO</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fin Grupos de  Beneficios -->
          </div>
        </div>
        <!--- -->

        <!-- borrado -->

        <!-- fin de borrado -->
      </template>
      <!-- ver listado promociones -->

      <!-- fin ver listado promociones -->
      <!-- ver listado editar promociones -->
      <template v-if="listar == 51">
        <div class="card-body">
          <div class="form-group row">
            <!--incio de buscador-->
            <!--
            <div class="col-md-12 invisible">
              <div class="input-group" style="font-size: 12px">
                <div>
                  <div
                    class="card-header"
                    style="height: 30px; background-color: #ebeef6"
                  >
                    Código&nbsp;promoción
                  </div>
                  <input
                    type="number"
                    v-model="buscar"
                    placeholder="Código promoción"
                    style="font-size: 12px; width: 150px; height: 32px"
                    @keyup.enter="listarPromocionesLike(3)"
                    title="Código promoción"
                  />
                </div>
                <div>
                  <div
                    class="card-header"
                    style="height: 30px; background-color: #ebeef6"
                  >
                    Nombre&nbsp;promoción
                  </div>
                  <input
                    type="text"
                    v-model="buscar2"
                    placeholder="Nombre Promoción"
                    style="font-size: 12px; width: 320px; height: 32px"
                    @keyup.enter="listarPromocionesLike(1)"
                    title="Nombre Promoción"
                  />
                </div>
                <div>
                  <div
                    class="card-header"
                    style="height: 30px; background-color: #ebeef6"
                  >
                    Estado
                  </div>
                  <select
                    style="font-size: 12px; width: 150px; height: 32px"
                    v-model="buscar3"
                    @change="listarPromocionesLike(1)"
                    title="Estado"
                  >
                    <option value="Estado">Todos</option>

                    <option value="Activo">Activo</option>

                    <option value="Finalizado">Finalizado</option>
                  </select>
                </div>
                <div>
                  <div
                    class="card-header"
                    style="height: 30px; background-color: #ebeef6"
                  >
                    Modalidad
                  </div>
                  <select
                    v-model="buscar4"
                    @change="listarPromocionesLike(1)"
                    title="Modalidad"
                    style="font-size: 12px; width: 175px; height: 32px"
                  >
                    <option value="0">Todos</option>
                    <option value="Medicación Frecuente">
                      Medicación Frecuente
                    </option>
                    <option value="Tratamiento Completo">
                      Tratamiento Completo
                    </option>
                    <option value="Consumo masivo">Consumo masivo</option>
                  </select>
                </div>
                <div>
                  <button
                    type="submit"
                    @click="listarPromocionesLike(1)"
                    class="btn btn-secondary"
                    style="font-size: 14px; height: 56px"
                  >
                    <i class="fa fa-search"></i> Buscar</button
                  >&nbsp;&nbsp;
                </div>
              </div>
              <div class="input-group" style="font-size: 12px">
                <div>
                  <div
                    class="text-start card-header"
                    style="height: 35px; background-color: #ebeef6"
                  >
                    <label class="text-start fw-bold"
                      >Buscar&nbsp;productos&nbsp;por:</label
                    >&nbsp;Código
                    <label class="switch">
                      <input
                        type="checkbox"
                        v-model="selectCodDes"
                        true-value="1"
                        false-value="0"
                      />
                      <span class="slider round"></span> </label
                    >&nbsp;&nbsp;Nombre
                  </div>
                  <input
                    type="text"
                    v-model="buscar2"
                    placeholder="Nombre producto"
                    style="font-size: 12px; width: 350px; height: 32px"
                    @keyup.enter="listarPromocionesLike(1)"
                    title="Nombre producto"
                  />
                </div>
                <div>
                  <div
                    class="card-header"
                    style="height: 35px; background-color: #ebeef6"
                  >
                    Ubicación
                  </div>
                  <select
                    style="font-size: 12px; width: 160px; height: 32px"
                    v-model="buscar344"
                    @change="listarPromocionesLike(1)"
                    title="Estado"
                  >
                    <option value="3">Todos</option>
                    <option value="1">Condición</option>
                    <option value="2">Beneficio</option>
                  </select>
                </div>
              </div>
            </div>
          -->

            <div class="row content">
              <div class="text-star col-md-1">
                <label
                  class="text-star labelRC"
                  style="background: #ffffff; padding: 10px 0; font-size: 11px"
                  >Buscar&nbsp;por:</label
                >
              </div>
              <div class="text-star col-md-3">
                <input
                  type="radio"
                  id="Nombre"
                  value="Nombre"
                  v-model="selectFilterLike"
                  @change="seleccionarProdCB()"
                />
                <label
                  class="text-star labelRC"
                  for="Nombre"
                  style="width: 210px"
                  >Nombre&nbsp;de&nbsp;promoción</label
                >
              </div>
              <div class="text-star col-md-2">
                <input
                  type="radio"
                  id="Productos"
                  value="Productos"
                  v-model="selectFilterLike"
                  @change="seleccionarProdCB()"
                />
                <label
                  class="text-star labelRC"
                  for="Productos"
                  style="width: 160px"
                  >Productos</label
                >
              </div>
              <div v-if="selectPCB == 1" class="col-md-5">
                <div class="contentS row">
                  <div class="text-star col-md-6">
                    <input
                      type="checkbox"
                      id="radio3"
                      name="radio03"
                      class="chk-cb"
                      true-value="1"
                      false-value="0"
                      v-model="selectCond"
                      @click="seleccionarProd(1)"
                    />
                    <label class="labelRCB" for="radio3"
                      >Condición&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label
                    >
                  </div>
                  <div class="text-star col-md-6">
                    <input
                      type="checkbox"
                      id="radio4"
                      name="radio04"
                      class="chk-cb"
                      true-value="1"
                      false-value="0"
                      v-model="selectBenef"
                      @click="seleccionarProd(2)"
                    />
                    <label class="labelRCB" for="radio4"
                      >Beneficio&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label
                    >
                  </div>
                </div>
              </div>

              <div class="form-group row input-group col-md-12">
                <div class="input-group col-md-12">
                  <div>
                    <div
                      class="text-start"
                      style="
                        height: 15px;
                        font-size: 10px;

                        padding-top: 1px;
                        font-weight: bold;
                      "
                    >
                      <label style="width: 100px">Ingresar búsqueda:</label>
                    </div>
                    <input
                      type="text"
                      v-model="buscarlike"
                      placeholder="Ingresar búsqueda"
                      style="font-size: 12px; width: 410px; height: 32px"
                      @keyup.enter="listarPromocionesLikeCB(1)"
                      title="Ingresar búsqueda"
                    />
                  </div>
                  <div>
                    <div
                      class="text-start"
                      style="
                        height: 15px;
                        font-size: 10px;

                        padding-top: 1px;
                        font-weight: bold;
                      "
                    >
                      Estado:
                    </div>
                    <select
                      style="font-size: 12px; width: 240px; height: 32px"
                      v-model="buscarEstado"
                      @change="listarPromocionesLikeEstado(1)"
                      title="Estado"
                    >
                      <option value="Estado">Todos</option>
                      <option value="Activo">Activo</option>
                      <option value="Finalizado">Finalizado</option>
                    </select>
                  </div>
                  <div>
                    <div
                      class="text-start"
                      style="
                        height: 15px;
                        font-size: 10px;

                        padding-top: 1px;
                        font-weight: bold;
                      "
                    >
                      Modalidad:
                    </div>
                    <select
                      v-model="buscarModalidad"
                      @change="listarPromocionesLikeModalidad()"
                      title="Modalidad"
                      style="font-size: 12px; width: 220px; height: 32px"
                    >
                      <option value="0">Todos</option>
                      <option value="Medicación Frecuente">
                        Medicación Frecuente
                      </option>
                      <option value="Tratamiento Completo">
                        Tratamiento Completo
                      </option>
                      <option value="Consumo masivo">Consumo masivo</option>
                    </select>
                  </div>
                  <div>
                    <div
                      class="text-start"
                      style="
                        height: 15px;
                        font-size: 10px;

                        padding-top: 1px;
                        font-weight: bold;
                      "
                    >
                      &nbsp;
                    </div>
                    <button
                      type="submit"
                      @click="procesarPromosBusqueda()"
                      class="btn btn-secondary"
                      style="font-size: 12px; height: 32px"
                    >
                      <i class="fa fa-search"></i> Buscar</button
                    >&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-2"></div>
            <div><hr /></div>

            <!-- fin de buscador -->
            <!-- inicio de la tabla -->
            <div class="table-responsive">
              <table class="table table-bordered table-sm" width="100%">
                <thead>
                  <tr>
                    <!-- <th>Usuario</th> -->
                    <th v-if="activarSelect == 1">
                      Seleccionar

                      <input
                        type="checkbox"
                        true-value="1"
                        false-value="0"
                        v-model="selectTodo"
                        @click="seleccionarTodo(selectTodo)"
                      />
                    </th>
                    <th>Código<br />Promoción<br /></th>
                    <th width="30%">Nombre<br /></th>
                    <th>Modalidad<br /></th>
                    <th>Fecha<br />Inicio<br /></th>
                    <th>Fecha<br />Fin<br /></th>
                    <th>Mecánica<br /></th>
                    <!--
                    <th>Proveedor</th>
                    <th>Laboratorio</th>
                    -->
                    <th>Estado<br /></th>
                    <th colspan="1">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="promocion in arrayPromocionesAll"
                    :key="promocion.codigoPromocion"
                  >
                    <td
                      v-if="promocion.nombre.indexOf('COPIA') >= 0"
                      style="
                        font-size: 11px;
                        text-align: center;
                        background-color: #96dbeb;
                        width: 10%;
                      "
                      class="table-warning"
                      v-text="promocion.codigoPromocion"
                    ></td>
                    <td
                      v-else
                      style="font-size: 11px"
                      v-text="promocion.codigoPromocion"
                    ></td>
                    <td
                      v-if="promocion.nombre.indexOf('COPIA') >= 0"
                      style="
                        font-size: 11px;
                        text-align: left;
                        background-color: #96dbeb;
                      "
                      class="table-warning"
                      v-text="promocion.nombre"
                    ></td>
                    <td
                      v-else
                      style="font-size: 11px; text-align: left"
                      v-text="promocion.nombre"
                    ></td>
                    <td
                      v-if="promocion.nombre.indexOf('COPIA') >= 0"
                      style="
                        font-size: 11px;
                        text-align: center;
                        background-color: #96dbeb;
                      "
                      class="table-warning"
                      v-text="promocion.tipoMF"
                    ></td>
                    <td
                      v-else
                      style="font-size: 11px"
                      v-text="promocion.tipoMF"
                    ></td>
                    <td
                      v-if="promocion.nombre.indexOf('COPIA') >= 0"
                      style="
                        font-size: 11px;
                        text-align: center;
                        background-color: #96dbeb;
                      "
                      class="table-warning"
                      v-text="promocion.fechaInicio"
                    ></td>
                    <td
                      v-else
                      style="font-size: 11px"
                      v-text="promocion.fechaInicio"
                    ></td>
                    <td
                      v-if="promocion.nombre.indexOf('COPIA') >= 0"
                      style="
                        font-size: 11px;
                        text-align: center;
                        background-color: #96dbeb;
                      "
                      class="table-warning"
                      v-text="promocion.fechaFin"
                    ></td>
                    <td
                      v-else
                      style="font-size: 11px"
                      v-text="promocion.fechaFin"
                    ></td>

                    <td
                      v-if="promocion.nombre.indexOf('COPIA') >= 0"
                      style="
                        font-size: 11px;
                        text-align: center;
                        background-color: #96dbeb;
                      "
                      class="table-warning"
                      v-text="promocion.mecanica"
                    ></td>
                    <td
                      v-else
                      style="font-size: 11px"
                      v-text="promocion.mecanica"
                    ></td>

                    <td
                      v-if="
                        promocion.nombre.indexOf('COPIA') >= 0 &&
                        promocion.estado === 'Cancelado'
                      "
                      style="
                        font-size: 11px;
                        color: red;
                        background-color: #96dbeb;
                      "
                      v-text="promocion.estado"
                    ></td>
                    <td
                      v-else-if="
                        promocion.nombre.indexOf('COPIA') >= 0 &&
                        promocion.estado != 'Cancelado'
                      "
                      style="font-size: 11px; background-color: #96dbeb"
                      v-text="promocion.estado"
                    ></td>
                    <td
                      v-else-if="promocion.estado === 'Cancelado'"
                      style="font-size: 11px; color: red"
                      v-text="promocion.estado"
                    ></td>
                    <td
                      v-else
                      style="font-size: 11px"
                      v-text="promocion.estado"
                    ></td>
                    <td>
                      <div class="btn-group btn-sm border">
                        <button
                          type="button"
                          class="btn btn-sm"
                          style="font-size: 11px"
                        >
                          <i class="fas fa-tools"></i>
                        </button>
                        <button
                          type="button"
                          class="btn dropdown-toggle dropdown-toggle-split btn-sm"
                          id="dropdownMenuReference"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          data-bs-reference="parent"
                        >
                          <span class="visually-hidden">Toggle Dropdown</span>
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuReference"
                        >
                          <li>
                            <a
                              class="dropdown-item"
                              style="font-size: 12px"
                              @click="
                                verPromocion(promocion.codigoPromocion, 0)
                              "
                              ><i class="fas fa-eye"></i>&nbsp;Ver detalle</a
                            >
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="arrayPromocionesAll.length < 4">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>

              <nav v-if="paginasTotal > 0" aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    <a class="page-link" href="#" @click="prevPage()"
                      ><i class="fas fa-fast-backward"></i
                    ></a>
                  </li>
                  <li
                    v-for="n in paginasTotal"
                    :key="n"
                    class="page-item list-group-item-secondary"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click="fitrarPromociones(n)"
                      >{{ n }}</a
                    >
                  </li>

                  <li class="page-item">
                    <a class="page-link" href="#" @click="nextPage()"
                      ><i class="fas fa-fast-forward"></i
                    ></a>
                  </li>
                  <li>
                    <a class="page-link" href="#">
                      &nbsp;&nbsp;<i></i>Página ({{ paginaActiva }})
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <br />
            <br />
            <!-- fin de la tabla-->
            <!-- Incio Mostrar encabezado promocion -->
          </div>
        </div>
        <!--- -->

        <!-- borrado -->

        <!-- fin de borrado -->
      </template>
      <!-- fin ver listado editar promociones -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/styleRC.css";
//import Cuerpo from './components/Cuerpo.vue';
//import Promocion from "./components/Promocion.js";
//import Encabezado from "./components/Encabezado.vue";
import TextReaderP from "../service/TextReaderProducto";
import TextReaderC from "../service/TextReaderCiudad";
import TextReaderO from "../service/TextReaderOficina";
import TextReaderPr from "../service/TextReaderProvincia";
import TextReaderR from "../service/TextReaderRegion";
import TextReaderS from "../service/TextReaderSucursal";

import PromoService from "../service/PromocionDataService";
import FechaService from "../service/FechaService";
import IPServie from "../service/ConectionDataService";
import Token from "../service/TokenValidate";
//import Multiselect from "@vueform/multiselect";
import RolesUser from "@/views/service/RolesUser.js";
export default {
  name: "App",
  data() {
    return {
      //http_local: "http://localhost:8080",
      //http_remote: "http://192.168.236.242:8080",
      //filter
      filtrarLike: "Nombre",
      selectFilterLike: "Nombre",
      selectPCB: 0,
      selectCond: 1,
      selectBenef: 1,
      buscarlike: "",
      buscarEstado: "Estado",
      buscarModalidad: "0",

      aarray: [],
      arrayCondicionesProcess: [],
      arrayCondicionesProcessT: [],
      arrayBeneficiosProcess: [],
      arrayBeneficiosProcessT: [],
      arrayOficinasProcess: [],
      arrayOficinasProcessT: [],
      arraySucursalesProcess: [],
      buscarOficinaLk: "",
      buscarCondicionesLk: "",
      buscarBeneficiosLk: "",
      statusConfig: 0,
      selectCodDesC: 0,
      selectCodDesB: 0,
      selectCodDesO: 0,

      http_: "",
      modulos: [],
      selectTodo: 0,
      paginasTotal: 0,
      paginaActiva: 1,
      controlPaginas: 0,
      //buscar Like
      listaCodigos: "",
      arraryBuscarLike: [],
      palabraClaveLike: "",
      buscarPalabraLike: "",
      mostrarComboLike: false,
      // modalCabecera
      modalCabecera: 0,
      tituloModal: "MI MODAL",
      nombreCRM: "",
      usuario: "",
      usuarioModifica: "",
      fechaRegistro: "",
      fechaUltimoCambio: "",
      estado_proceso: 0, //0:ver registro/1:para editar
      estado_procesoCabecera: 0,
      pagina: 0,
      codigoPromocionDuplicar: [],
      //buscar_
      buscar: "",
      buscar2: "",
      buscar3: "Estado",
      buscar4: "0",
      criterio: "codigoPromocion",
      criterio2: "nombre",
      criterio3: "estado",
      criterio4: "tipoMF",
      controlBusqueda: 0,
      //
      persona_id: 0,
      nombre: "",
      apellido: "",
      direccion: "",
      telefono: "",
      listar: 3,
      arrayPersona: "",
      pageNumber: 1,
      pageSize: 10,
      //inicio encabezado
      codigoPromocion: "",
      codigoPadre: "",
      nombrePromocion: "",
      observacionesPromocion: "",
      fechaInicio: "",
      fechaInicioSistema: "",
      fechaFin: "",
      fechaFinTemporal: "",
      mecanica: "",
      mecanicaValor: 0,
      mecanicaBonificacion: 0,
      periodoCanje: "0",
      unidadPeriodoCanje: "Meses",
      mesPendienteCanje: "1",
      acumulacionCajas: true,
      tipoAcumulacion: "Acumulable",
      tipoMF: "Medicación Frecuente",
      estadoPromocion: "Pendiente",
      fechaInicioAcumulacion: "00/00/0000 00:00",
      noAplicaFIAC: true,
      existePromocion: 0,
      compararFecha: 0,
      mensaje: "Acumula",
      responsablePromo: "0",
      lineaCSolicitante: "0",
      razones: "",

      generaCobro: "SI",
      arrayGeneraCobro: [],
      asumeCategoria: "NO",
      arrayAsumeCategoria: [],
      casos: 0,
      casos_condiciones: 0,
      casos_parte: 0,
      casos_condicion: 0,
      casos_condicion_btn: 0,
      guardaActualiza: 0, //0 guarda 1 actualiza
      //fin encabezado
      //grupos
      grupoCondiciones: [],
      nombreGrupo: "A",
      codigoGrupo: "",
      operadorGrupo: "OR",
      condiciones: [],
      arrayGrupoCondiciones: [], // para capturar la condicíon al momento de fuardar
      //fin de grupos
      // tipo condiciones
      condiciones_id: 0,
      tipoCondicion: "",
      codigoProducto: "",
      codigoPrdAcu: "",
      //
      acumulaCajas: "SI",
      esAcumulable: "SI",

      acumulaCajasCondicion: true,
      esAcumulableCondicion: true,
      retieneCajasCondicion: "SI",
      cantidadCondicion: 0,
      tipoCondicionOY: "",
      condicionCanje: true,
      condicionAcumulacion: true,

      btnFinalizar: "",
      btnfinalizarR: 0,

      arrayTipoCondiciones: [],
      listarMostrarCondicion: 0,
      cantidadProducto: 0,
      operadorCondiciones: "OR",
      precioProducto: 0,
      regionesCondicion: "",
      provinciasCondicion: "",
      ciudadesCondicion: "",
      oficinas: "",

      //condiciones complejas
      relacionAcumulacionCond: 1,
      cumplimientoCond: "individual",
      relacionAcumulacionBenef: 1,

      // fin tipo condiciones
      arrayCondicionesAceptadas: [],

      //Beneficios
      arrayBeneficios: [],
      tipoBenef: "productos",
      codigoProductoBenef: "",
      descuentoBenef: 0,
      cantidadBenef: "",
      operadorBenef: "OR",
      limiteAplicacion: 0,
      limiteCanje: 0,
      indicePadreBenef: 0,
      arrayCombinacionBenef: [],
      arrayCodNombBenef: [],
      indicePadreBeneficio: 0,
      //Proveedor Laboratorio
      modalProvLabSec: 0,

      //Aplicacion
      codigoaplicacion: "1",

      //sucursal:"",
      sucursal: {
        mode: "tags",
        value: ["Todas"],
        options: [
          { codigo: "002", sucursal: "MEDICITY" },
          { codigo: "003", sucursal: "ECONOMICAS" },
          { codigo: "012", sucursal: "PUNTO VITAL" },
          { codigo: "009", sucursal: "PLAN ADMINISTRACION FARMACIAS" },
        ],

        searchable: true,
        createTag: true,
      },
      check_sucursal: "Todas",

      segmento: {
        mode: "tags",
        value: ["Todas"],
        options: [
          { value: "001", label: "SEGMENTO A" },
          { value: "002", label: "SEGMENTO C" },
          { value: "003", label: "SEGMENTO B" },
          { value: "004", label: "SEGMENTO D" },
          { value: "005", label: "SEGMENTO E" },
        ],
        searchable: true,
        createTag: true,
      },

      responsable: {
        options: [
          { value: "001", label: "RESPONSABLE 1" },
          { value: "002", label: "RESPONSABLE 2" },
          { value: "003", label: "RESPONSABLE 3" },
          { value: "004", label: "RESPONSABLE 4" },
        ],
      },
      //condiciones
      //buscador
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0,
      },
      idEditar: 0,

      //arrays
      arrayPromocionesAll: [],
      arrayPromocionesAll_all: [],
      arrayPromocionesAll_pag: [],
      arrayPromocionesAll_ES: [], // estado
      arrayPromocionesAll_MD: [], //  modalidad
      //arbol de condiciones
      bandera: 0,
      indicePadre: 0,
      indiceHijoEdit: 0,
      idPadre: 0,
      indiceHijo: 0,
      idHijo: 0,
      hijoName: "",
      padreSeleccionado: 0,
      nombreA: "",
      idva: 0,
      arrayItem: [],
      arrayItemDetalle: [],
      arrayItemDetalleAx: [],
      dat: [],
      mensajeCondicion: "",
      arrayItemBenef: [],
      //mensales
      modalMensajes: 0,
      condicion_mensajes: 0,
      condicion_mensajesVer: 0,
      idxMensajePromo: 0, // index del array de mensaje promocion
      mensajePromo: "",
      controlVistaPrevMsj: 0,
      mensajePromoVistaPrev: "",
      mensajePromoVistaPrevTemp: "",
      palabraClave: "",
      tipoMensaje: "Acumulación",
      arrayVariables: [],
      arrayMensajes: [],
      arrayMensajesAll: [],
      arrayMensajesPromocion: [],
      arrayMensajesPromocionTipos: [],
      //cobros
      modalCobros: 0,
      //extension
      modalExtension: 0,
      controlExtension: 0,
      controlExtensionCancel: 0,
      modalCondiciones: 0,

      condicion_cobros: 0,
      arrayCobros: [],
      metodoAplicacion: "Porcentaje",
      listaCobro: "ppp",
      tipoPagador: "Farmaenlace",
      valorCobro: 0,
      porcentajeCobro: 0,
      totalPorCobro: 0,
      proveedor: [],
      lineaComercial: {
        mode: "tags",
        value: ["Todas"],
        options: [],
        searchable: true,
        createTag: true,
      },
      errorPromoLgth: 0,
      errorMostrarMsjPromo: [],
      activarSelect: 0,
      modalVistaPrevia: 0,
      textoCodProd: "", // vista previa productos
      empresa_RUC: "",
      empresa_NC: "",
      //paginado directo
      current_page_all: 1,
      obj_per_page: 50,
    };
  },
  methods: {
    buscarLikeProd(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;

      if (me.buscarPalabraLike.length == 0 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        url =
          me.http_ +
          "/acumulacion/mf/productos/allLike/" +
          me.buscarPalabraLike.toUpperCase();
      }

      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
    },
    buscarLikeOficina(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;
      if (me.buscarPalabraLike.length == 0 || keycode == 32 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        url =
          me.http_ +
          "/acumulacion/mf/registroOficina/allLike/" +
          me.buscarPalabraLike.toUpperCase();
      }
      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
          console.log(me.arraryBuscarLike);
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
    },
    buscarLikeSucursal(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;
      if (me.buscarPalabraLike.length == 0 || keycode == 32 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        //url = me.http_ + "/acumulacion/mf/regiones/allLikeR/" + me.buscarPalabraLike.toUpperCase();
        me.arraryBuscarLike = me.sucursal.options;
      }
      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
          console.log(me.arraryBuscarLike);
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
    },
    buscarLikeRegion(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;
      if (me.buscarPalabraLike.length == 0 || keycode == 32 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        url =
          me.http_ +
          "/acumulacion/mf/regiones/allLikeR/" +
          me.buscarPalabraLike.toUpperCase();
      }
      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
          console.log(me.arraryBuscarLike);
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
    },
    buscarLikeProvincia(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;
      if (me.buscarPalabraLike.length == 0 || keycode == 32 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        url =
          me.http_ +
          "/acumulacion/mf/regiones/allLikeP/" +
          me.buscarPalabraLike.toUpperCase();
      }
      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
          console.log(me.arraryBuscarLike);
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
    },
    buscarLikeCiudad(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;
      if (me.buscarPalabraLike.length == 0 || keycode == 32 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        url =
          me.http_ +
          "/acumulacion/mf/regiones/allLikeC/" +
          me.buscarPalabraLike.toUpperCase();
      }
      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
          console.log(me.arraryBuscarLike);
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
    },
    buscarLikeProveedor(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;
      if (me.buscarPalabraLike.length == 0 || keycode == 32 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        url =
          me.http_ +
          "/acumulacion/mf/proveedores/allLike/" +
          me.buscarPalabraLike.toUpperCase();
        //me.arraryBuscarLike = me.proveedor;
      }
      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
          console.log(me.arraryBuscarLike);
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
      me.listaCodigos = "";
    },
    buscarLikeLineaComercial(event) {
      let me = this;
      me.mostrarComboLike = true;
      var url;
      var keycode = event.keyCode;
      if (me.buscarPalabraLike.length == 0 || keycode == 32 || keycode == 27) {
        me.mostrarComboLike = false;
      } else {
        //url =
        // me.http_ +
        // "/acumulacion/mf/regiones/allLikeC/" +
        // me.buscarPalabraLike.toUpperCase();
        me.arraryBuscarLike = me.lineaComercial.options;
      }
      axios
        .get(url)
        .then(function (response) {
          me.arraryBuscarLike = response.data;
          console.log(me.arraryBuscarLike);
        })
        .catch(function (error) {
          console.log(error);
        });

      if (keycode == 39 || keycode == 40) {
        me.$refs.palabraClaveLike.focus();
      }
      console.log(keycode);
      me.listaCodigos = "";
    },
    agregarBuscarLike() {
      let me = this;
      if (me.palabraClaveLike === "-1") {
        if (me.listaCodigos.length > 0) {
          me.listaCodigos =
            me.listaCodigos + "," + me.buscarPalabraLike.toUpperCase();
        } else {
          me.listaCodigos = me.buscarPalabraLike.toUpperCase();
        }
      } else {
        if (me.listaCodigos.length > 0) {
          me.listaCodigos = me.listaCodigos + "," + me.palabraClaveLike;
        } else {
          me.listaCodigos = me.palabraClaveLike;
        }
      }
      me.buscarPalabraLike = "";
      me.mostrarComboLike = false;
      me.$refs.buscarPalabraLike.focus();
    },
    limpiarCodigos() {
      let me = this;
      me.listaCodigos = me.listaCodigos.trim(); // limpiar espacios en blanco
      me.listaCodigos = me.listaCodigos.replace(/ /g, ""); // limpiar todos espacios en blanco
      me.listaCodigos = me.listaCodigos.replace(/\s+/g, ","); //limpiar espacios en blanco, saltos y tabulacion
      //console.log(".....revision de códigos");
      //console.log(me.listaCodigos);
    },
    limpiarCodigosTxt() {
      let me = this;
      me.listaCodigos = "";
    },
    //
    asignarGrupo(cod_grupo, val2, tipo_grupoPadre) {
      let me = this;

      if (me.arrayItem.length === 0 && cod_grupo === 2) {
        me.$swal({
          title: "Recuerde",
          icon: "warning",
          text: "Primero del menú 'Agrupaciones', seleccione opciones 'Puede ser..'",
          //showConfirmButton: false,
          //timer: 2000,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      if (tipo_grupoPadre === "Producto" && cod_grupo === 1) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Puede ser los productos",
          operador: "OR",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "Sectorizacion" && cod_grupo === 1) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Puede ser la sectorización",
          operador: "OR",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "Tiempo" && cod_grupo === 1) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Puede ser en los tiempos",
          operador: "OR",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "SegmentosClientes" && cod_grupo === 1) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Puede ser los segmentos de clientes",
          operador: "OR",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "productosbeneficios" && cod_grupo === 1) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Puede ser para Producto-Beneficio",
          operador: "OR",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "productoscombinados" && cod_grupo === 1) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Puede ser para Producto-Combinados",
          operador: "OR",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      // - 2
      if (tipo_grupoPadre === "Producto" && cod_grupo === 2) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Y necesita estos productos",
          operador: "AND",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "Sectorizacion" && cod_grupo === 2) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Y necesita la sectorización",
          operador: "AND",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "Tiempo" && cod_grupo === 2) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Y necesita los tiempos",
          operador: "AND",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "SegmentosClientes" && cod_grupo === 2) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Y para los segmentos de clientes",
          operador: "AND",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "productosbeneficios" && cod_grupo === 2) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Y necesita de Producto-Beneficio",
          operador: "AND",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
      if (tipo_grupoPadre === "productoscombinados" && cod_grupo === 2) {
        me.arrayItem.push({
          codigoGrupo: me.arrayItem.length + 1,
          nombreGrupo: "G. Y necesita de Producto-Combinados",
          operador: "AND",
          condiciones: [],
          aplicaComoBeneficio: "",
          //datos:me.arrayItemDetalle
        });
      }
    },
    asignarPadre() {
      let me = this;
      me.arrayItem.push({
        codigoGrupo: 1,
        nombreGrupo: "G. Puede ser los productos",
        operador: "OR",
        condiciones: [],
        aplicaComoBeneficio: "",
        //datos:me.arrayItemDetalle
      });
      console.log(me.arrayItem);
    },
    seleccionarPadre(val, indx) {
      let me = this;
      me.padreSeleccionado = indx;
      me.arrayItemDetalleAx = [];
      me.indicePadre = indx;
      me.idPadre = val;
      console.log(Number(val) + "-" + indx);
      me.dat = me.arrayItem.find((dato) => dato.codigoGrupo === val);
      console.log(me.dat.condiciones);
      if (me.dat.condiciones != null) {
        me.arrayItemDetalleAx = me.dat.condiciones;
        console.log("llena exis");
        me.bandera = 1;
      }
      //console.log(me.arrayItemDetalleAx);
      me.arrayItemDetalle = [];
      console.log(me.arrayItem);
    },
    eliminarPadre(index, padre) {
      let me = this;
      console.log("Indicex: " + index + " Padrex: " + padre);
      console.log(me.arrayItem);
      me.$swal({
        position: "top-end",
        title: "Está seguro de eliminar grupo de condiciones ?",
        text: "¡No podrá revertir el proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          me.$swal({
            position: "top-end",
            icon: "success",
            title: "Grupo eliminado.",
            showConfirmButton: false,
            timer: 1000,
          });

          for (let i = 0; i < me.arrayItem.length; i++) {
            console.log("Indicex");
            console.log(me.arrayItem[i]);
            //if (me.arrayItem[i].codigoGrupo == index) {
            if (i == index) {
              console.log("Padre eliminado");
              me.arrayItem.splice(i, 1);
            }
          }
          console.log(me.arrayItem);
          me.grupoCondiciones = me.arrayItem;
          me.registrarPromocionCondiciones();
          //me.arrayItemDetalle.splice(me.indiceHijo, 1);
        }
      });
    },
    asignarHijo() {
      let me = this;
      me.cambiarTipoAcumulacion();
      if (me.arrayItemDetalleAx.length > 0 && me.bandera == 1) {
        for (let i = 0; i < me.arrayItemDetalleAx.length; i++) {
          me.arrayItemDetalle.push(me.arrayItemDetalleAx[i]);
          me.bandera = 0;
        }
      }
      if (me.tipoCondicionOY == "productos") {
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          //codigoProducto: me.productos.value,
          cantidad: me.cantidadCondicion,
          acumulacionCajas: me.acumulaCajasCondicion,
          acumulable: me.esAcumulableCondicion,
          retieneCajas: me.retieneCajasCondicion,
          operador: me.operadorCondiciones,
        });
      } else if (me.tipoCondicionOY == "sucursal") {
        let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          //sucursal: me.listaCodigos.split(","),
          sucursal: arrayCodT,
          operador: me.operadorCondiciones,
          condicionCanje: me.condicionCanje,
          condicionAcumulacion: me.condicionAcumulacion,
        });
      } else if (me.tipoCondicionOY == "region") {
        let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          //region: me.listaCodigos.split(","),
          region: arrayCodT,
          operador: me.operadorCondiciones,
          condicionCanje: me.condicionCanje,
          condicionAcumulacion: me.condicionAcumulacion,
        });
      } else if (me.tipoCondicionOY == "provincia") {
        let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          //provincia: me.listaCodigos.split(","),
          provincia: arrayCodT,
          operador: me.operadorCondiciones,
          condicionCanje: me.condicionCanje,
          condicionAcumulacion: me.condicionAcumulacion,
        });
      } else if (me.tipoCondicionOY == "ciudad") {
        let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          //ciudad: me.listaCodigos.split(","),
          ciudad: arrayCodT,
          operador: me.operadorCondiciones,
          condicionCanje: me.condicionCanje,
          condicionAcumulacion: me.condicionAcumulacion,
        });
      } else if (me.tipoCondicionOY == "oficina") {
        let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          oficina: arrayCodT,
          operador: me.operadorCondiciones,
          condicionCanje: me.condicionCanje,
          condicionAcumulacion: me.condicionAcumulacion,
        });
      } else if (me.tipoCondicionOY == "segmentosClientes") {
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          //segmento: me.segmento.value,
          segmento: me.listaCodigos.split(","),
          operador: me.operadorCondiciones,
          condicionCanje: me.condicionCanje,
          condicionAcumulacion: me.condicionAcumulacion,
        });
      } else if (me.tipoCondicionOY == "productosbeneficios") {
        var arrayBeneficioProducto = [];

        arrayBeneficioProducto.push({
          relacion: me.relacionAcumulacionBenef,
          limiteAplicacion: me.limiteAplicacion,
          limiteCanje: me.limiteCanje,
          cantidad: me.cantidadBenef,
          pagadoresDeuda: me.arrayCobros,
        });
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          cantidad: me.cantidadCondicion,
          //codigoProducto: me.productos.value,
          operador: me.operadorCondiciones,
          //condicionCanje: me.condicionCanje,
          //condicionAcumulacion: me.condicionAcumulacion,
          acumulacionCajas: me.acumulaCajasCondicion,
          acumulable: me.esAcumulableCondicion,

          relacion: me.relacionAcumulacionCond,
          //cumplimiento: me.cumplimientoCond,
          beneficioProducto: arrayBeneficioProducto,
        });
      } else if (me.tipoCondicionOY == "productoscombinados") {
        //var arrayBeneficioProducto=[];
        me.limpiarCodigos();
        let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));

        console.log(arrayCodT);
        me.arrayItemDetalle.push({
          idPadre: me.idPadre,
          idHijo: me.arrayItemDetalle.length + 1,
          mensajeCondicion: me.mensajeCondicion,
          tipo: me.tipoCondicionOY,
          cantidad: me.cantidadCondicion,

          //codigoProducto: me.listaCodigos.split(","),
          codigoProducto: arrayCodT,
          operador: me.operadorCondiciones,
          acumulacionCajas: me.acumulaCajasCondicion,
          acumulable: me.esAcumulableCondicion,
          relacion: me.relacionAcumulacionCond,
          //cumplimiento: me.cumplimientoCond,
        });
      }
      //console.log("Acumulado");
      //console.log(me.arrayItemDetalle);
      me.dat.condiciones = me.arrayItemDetalle;
      //console.log("Asigna hijo");
      //console.log(me.dat);
      //console.log("antes de asignar  hijo: " + me.indicePadre);
      //console.log(me.arrayItem);
      me.arrayItem[me.indicePadre] = me.dat;
      //console.log(me.arrayItem);
      me.grupoCondiciones = me.arrayItem;
      me.registrarPromocionCondiciones();
      me.cerrarModalCondiciones();
      me.cerrarModalProvLabSec();
    },
    validarArrayCondicion(arrayC) {
      //let me = this;

      //console.log("Validando array");
      for (var i = 0, j = arrayC.length; i < j; i++) {
        if (arrayC[i] == "") {
          arrayC.splice(i, 1);
          i--;
        }
      }
      //console.log(arrayC);
      return arrayC;
    },
    seleccionarHijo(index, hijo, padre) {
      let me = this;
      me.indiceHijo = index;
      //console.log("hijo.");
      console.log(
        me.indicePadre + "::" + me.indiceHijo + " - " + hijo + " - " + padre
      );
    },
    eliminarHijo(index, hijo, padre) {
      let me = this;
      let tmd = [];
      console.log("Indx: " + index + " Hijo: " + hijo + " Padre: " + padre);
      console.log(me.arrayItem);
      me.$swal({
        position: "top-end",
        title: "Está seguro de eliminar la condición ?",
        text: "¡No podrá revertir el proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          me.$swal({
            position: "top-end",
            icon: "success",
            title: "Conción eliminada.",
            showConfirmButton: false,
            timer: 1000,
          });

          for (let i = 0; i < me.arrayItem.length; i++) {
            //console.log(me.arrayItem[i]);
            console.log("Nuevo");
            tmd = me.arrayItem[i].condiciones;
            //console.log(me.arrayItem[i].valor);
            if (me.arrayItem[i].codigoGrupo == padre) {
              for (let j = 0; j < tmd.length; j++) {
                console.log("hijo");
                //console.log(j);
                if (tmd[j].idHijo == hijo) {
                  console.log("borrando" + j);
                  tmd.splice(j, 1);
                  //console.log(tmd);
                  //me.arrayItem[i].nuevo[j].splice(j,1);
                  me.arrayItem[i].condiciones = tmd;
                }
              }
            }
          }
          me.grupoCondiciones = me.arrayItem;
          me.registrarPromocionCondiciones();
          //me.arrayItemDetalle.splice(me.indiceHijo, 1);
        }
      });
    },
    asignarPadreBenef() {
      let me = this;
      me.limpiarCodigos();
      let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
      me.arrayItemBenef.push({
        idPadreBenef: me.arrayItemBenef.length + 1,
        tipo: "productos",
        //codigoProducto: me.productos.value,
        //codigoProducto: me.listaCodigos.split(","),
        codigoProducto: arrayCodT,
        operador: me.operadorCondiciones,
        mensajeBeneficio: me.mensajeCondicion,
        cantidad: me.cantidadBenef,
        descuento: 100,
        limiteAplicacion: me.limiteAplicacion,
        limiteCanje: me.limiteCanje,
        pagadoresDeuda: [],

        //pagadoresDeuda:[],
      });
      me.arrayBeneficios = me.arrayItemBenef;
      me.registrarPromocionBeneficios();
      me.cerrarModalCondiciones();
    },
    eliminarPadreBenef(index, padre) {
      let me = this;
      console.log("Indicex: " + index + " Padrex: " + padre);
      console.log(me.arrayItemBenef);
      me.$swal({
        position: "top-end",
        title: "Está seguro de eliminar el beneficio ?",
        text: "¡No podrá revertir el proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          me.$swal({
            position: "top-end",
            icon: "success",
            title: "Beneficio eliminado.",
            showConfirmButton: false,
            timer: 1000,
          });

          for (let i = 0; i < me.arrayItemBenef.length; i++) {
            console.log("Indicex B");
            console.log(me.arrayItemBenef[i]);
            //if (me.arrayItem[i].codigoGrupo == index) {
            if (i == index) {
              console.log("Padre Benef eliminado");
              me.arrayItemBenef.splice(i, 1);
            }
          }
          console.log(me.arrayItemBenef);
          me.arrayBeneficios = me.arrayItemBenef;
          me.registrarPromocionBeneficios();
          //me.arrayItemDetalle.splice(me.indiceHijo, 1);
        }
      });
    },
    actualizarHijoProd() {
      let me = this;
      var arrayTmp = [];
      me.cambiarTipoAcumulacion();
      me.limpiarCodigos();
      let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
      for (let i = 0; i < me.arrayItem.length; i++) {
        if (me.indicePadre == i) {
          arrayTmp = me.arrayItem[i].condiciones;
          for (let j = 0; j < arrayTmp.length; j++) {
            if (me.indiceHijoEdit == j) {
              //console.log("cambiando");
              me.arrayItem[i].condiciones[j].cantidad = me.cantidadCondicion;
              me.arrayItem[i].condiciones[j].acumulacionCajas =
                me.acumulaCajasCondicion;
              me.arrayItem[i].condiciones[j].acumulable =
                me.esAcumulableCondicion;
              //me.arrayItem[i].condiciones[j].codigoProducto = me.productos.value;
              //me.arrayItem[i].condiciones[j].codigoProducto = me.listaCodigos.split(",");
              me.arrayItem[i].condiciones[j].codigoProducto = arrayCodT;
              me.arrayItem[i].condiciones[j].relacion =
                me.relacionAcumulacionCond;
              //arrayTmp[j].cantidad =100;
            }
          }
        }
        me.grupoCondiciones = me.arrayItem;
        me.registrarPromocionCondiciones();
      }
      me.cerrarModalCondiciones();
    },
    actualizarHijoCond() {
      let me = this;
      var arrayTmp = [];
      let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
      for (let i = 0; i < me.arrayItem.length; i++) {
        if (me.indicePadre == i) {
          arrayTmp = me.arrayItem[i].condiciones;
          for (let j = 0; j < arrayTmp.length; j++) {
            if (me.indiceHijoEdit == j) {
              if (me.tipoCondicionOY == "sucursal") {
                me.arrayItem[i].condiciones[j].condicionAcumulacion =
                  me.condicionAcumulacion;
                me.arrayItem[i].condiciones[j].condicionCanje =
                  me.condicionCanje;
                //me.arrayItem[i].condiciones[j].sucursal = me.listaCodigos.split(",");
                me.arrayItem[i].condiciones[j].sucursal = arrayCodT;
              } else if (me.tipoCondicionOY == "region") {
                me.arrayItem[i].condiciones[j].condicionAcumulacion =
                  me.condicionAcumulacion;
                me.arrayItem[i].condiciones[j].condicionCanje =
                  me.condicionCanje;
                //me.arrayItem[i].condiciones[j].region = me.listaCodigos.split(",");
                me.arrayItem[i].condiciones[j].region = arrayCodT;
              } else if (me.tipoCondicionOY == "provincia") {
                me.arrayItem[i].condiciones[j].condicionAcumulacion =
                  me.condicionAcumulacion;
                me.arrayItem[i].condiciones[j].condicionCanje =
                  me.condicionCanje;
                //me.arrayItem[i].condiciones[j].provincia = me.listaCodigos.split(",");
                me.arrayItem[i].condiciones[j].provincia = arrayCodT;
              } else if (me.tipoCondicionOY == "ciudad") {
                me.arrayItem[i].condiciones[j].condicionAcumulacion =
                  me.condicionAcumulacion;
                me.arrayItem[i].condiciones[j].condicionCanje =
                  me.condicionCanje;
                //me.arrayItem[i].condiciones[j].ciudad = me.listaCodigos.split(",");
                me.arrayItem[i].condiciones[j].ciudad = arrayCodT;
              } else if (me.tipoCondicionOY == "oficina") {
                me.arrayItem[i].condiciones[j].condicionAcumulacion =
                  me.condicionAcumulacion;
                me.arrayItem[i].condiciones[j].condicionCanje =
                  me.condicionCanje;
                //me.arrayItem[i].condiciones[j].oficina = me.listaCodigos.split(",");
                me.arrayItem[i].condiciones[j].oficina = arrayCodT;
              } else if (me.tipoCondicionOY == "segmentosClientes") {
                me.arrayItem[i].condiciones[j].condicionAcumulacion =
                  me.condicionAcumulacion;
                me.arrayItem[i].condiciones[j].condicionCanje =
                  me.condicionCanje;
                me.arrayItem[i].condiciones[j].segmento = arrayCodT;
                //me.arrayItem[i].condiciones[j].segmento = me.listaCodigos.split(",");
                //me.arrayItem[i].condiciones[j].segmento = me.segmento.value;
              }
            }
          }
        }
        me.grupoCondiciones = me.arrayItem;
        me.registrarPromocionCondiciones();
      }
      me.cerrarModalCondiciones();
      me.cerrarModalProvLabSec();
    },
    actualizarHijoProdBeneficio() {
      let me = this;
      me.limpiarCodigos();
      let arrayCodT = me.validarArrayCondicion(me.listaCodigos.split(","));
      for (let i = 0; i < me.arrayItemBenef.length; i++) {
        if (me.indicePadreBeneficio == i) {
          (me.arrayItemBenef[i].descuento = 100),
            //me.arrayItemBenef[i].codigoProducto = me.listaCodigos.split(","),
            (me.arrayItemBenef[i].codigoProducto = arrayCodT),
            (me.arrayItemBenef[i].cantidad = me.cantidadBenef);
          me.arrayItemBenef[i].limiteAplicacion = me.limiteAplicacion;
          me.arrayItemBenef[i].limiteCanje = me.limiteCanje;

          me.arrayBeneficios = me.arrayItemBenef;
          me.registrarPromocionBeneficios();
        }
      }
      me.cerrarModalCondiciones();
    },
    //---
    pasarPaginas(pag) {
      let me = this;
      me.paginaActiva = pag;
      console.log("pagina: " + pag);
      if (me.controlPaginas == 0) {
        me.listarPromociones(pag, "buscar", "criterio", 1, "codigoPromocion");
      } else {
        me.paginaActiva = pag;
        me.listarPromocionesLike(2);
      }
    },
    anterior() {
      let me = this;
      me.paginaActiva = 1;
      me.listarPromociones(
        me.paginaActiva,
        "buscar",
        "criterio",
        1,
        "codigoPromocion"
      );
    },
    siguiente() {
      let me = this;
      me.paginaActiva = me.paginasTotal;
      me.listarPromociones(
        me.paginaActiva,
        "buscar",
        "criterio",
        1,
        "codigoPromocion"
      );
    },
    cargaParametros() {
      let me = this;
      me.buscar = "";
      me.buscar2 = "";
      me.buscar3 = "Estado";
      me.buscar4 = "0";
      //me.selectTipoCondicion();
      me.listarPromociones(1, "buscar", "criterio", 1, "codigoPromocion");
      //me.listarVariablesMensajes();
      //me.listarOficinas();
      /*me.listarProveedores();
      me.listarGeneraCobro();
      me.listarAsumeCategoria();
      me.listarResponsable();
      me.listarLineaComercial();
      me.verEmpresa();
      */
    },
    //------------
    abrirModal(casos_, casos_parte_) {
      this.modalCabecera = 1;
      this.tituloModal = "Mi Modal Activo!!";

      this.casos = casos_;
      this.casos_parte = casos_parte_;
      if (
        (this.casos == 1 ||
          this.casos == 2 ||
          this.casos == 3 ||
          this.casos == 4 ||
          this.casos == 5 ||
          this.casos == 6) &&
        this.casos_parte == 0
      ) {
        this.nuevaPromocion(); //limpia nueva promocion listar == 3
        this.tituloModal = "Datos de la Promoción";

        this.casos_condicion = 1; //abrir modal de nuevapromocion casos_condicion === 1
        this.guardaActualiza = 0;
        this.estado_procesoCabecera = 0; // para modificar la cabecera
      }
      if (this.casos == 11 && this.casos_parte == 1) {
        this.tituloModal = "Editar encabezado de la Promoción"; // para actulizar encabezado de promocion casos_parte === 1
        this.casos_condicion = 1;
        this.guardaActualiza = 1;

        this.fechaInicio.length > 1
          ? (this.fechaInicio =
              this.fechaInicio.substring(0, 10) +
              "T" +
              this.fechaInicio.substring(11, 16))
          : (this.fechaInicio = "");
        if (this.fechaFin.length > 1)
          this.fechaFin =
            this.fechaFin.substring(0, 10) +
            "T" +
            this.fechaFin.substring(11, 16);
        if (this.fechaInicioAcumulacion.length > 1)
          this.fechaInicioAcumulacion =
            this.fechaInicioAcumulacion.substring(0, 10) +
            "T" +
            this.fechaInicioAcumulacion.substring(11, 16);
      }
      if (this.casos == 50) {
        this.tituloModal = "Editar Promoción";
        this.modalCabecera = 0;
        this.listar = 50;
      }
      if (this.casos == 51) {
        this.tituloModal = "Editar Promoción";
        this.modalCabecera = 0;
        this.listar = 51;
        //this.listarPromociones(1, "buscar", "criterio",1,'codigoPromocion');
        this.cargaParametros();
      }
      if (this.casos == 52) {
        this.tituloModal = "Duplicar Promoción";
        this.modalCabecera = 0;
        this.listar = 52;
      }
      if (this.casos == 10) {
        //mensajes
        this.tituloModal = "Mensajes!!";
        this.modalCabecera = 0;
        this.listar = 10;
        this.listarMensajes();
      }
      console.log("Casos: " + this.casos);
      //this.modalCabecera = 1;
    },
    abrirModalMensajes(val) {
      this.modalMensajes = 1;
      this.tituloModal = "Mensajes.";
      this.condicion_mensajes = val; //0 nuevo - 2  - 3 para editar en promociones
    },
    abrirModalExtensionCancel(codPromo, fechaIni, fechaFn, val_ex) {
      this.razones = "";
      console.log(val_ex);
      if (val_ex === 0) {
        this.controlExtensionCancel = 1;
        this.modalExtension = 1;
        this.tituloModal = "Extensión de una promoción.";
        this.codigoPromocion = codPromo;
        this.codigoPromocionDuplicar[0] = codPromo;
        this.fechaInicio =
          fechaIni.substring(0, 10) + "T" + fechaIni.substring(11, 16);
        this.fechaFinTemporal =
          fechaFn.substring(0, 10) + "T" + fechaFn.substring(11, 16);
        this.fechaFin = "";
        this.controlExtension = 0;
      }
      if (val_ex === 1) {
        this.controlExtensionCancel = 1;
        if (this.codigoPromocionDuplicar.length === 0) {
          this.$swal({
            position: "top-end",
            icon: "warning",
            title: "Seleccione al menos una promoción.",
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
        this.fechaFin = "";
        this.modalExtension = 1;
        this.controlExtension = 1;
        this.tituloModal = "Extensión promociones de forma masiva.";
        this.fechaFinTemporal = this.obtenerFechas();
        this.fechaFinTemporal =
          this.fechaFinTemporal.substring(0, 10) +
          "T" +
          this.fechaFinTemporal.substring(11, 16);
        //console.log(this.fechaFinTemporal);
        /*
        this.$swal({
          title: 'Recuerde',
          text: "Las promociones en estado 'Cancelado' no se van a extender la fecha fin",
          //icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar'
        })
        */
      }
      if (val_ex == 2) {
        this.modalExtension = 1;
        this.codigoPromocion = codPromo;
        this.controlExtensionCancel = 2;
        this.tituloModal = "Cancelar promociones.";
      }
      if (val_ex == 3) {
        this.modalExtension = 1;
        this.codigoPromocion = codPromo;
        this.controlExtensionCancel = 4;
        this.tituloModal = "Finalizar promociones.";
      }
    },
    abrirModalCobros(val, pagadoresDeuda, tipoCobro) {
      let me = this;
      //console.log(pagadoresDeuda[0].pagadoresDeuda);
      if (tipoCobro === "productos") {
        if (pagadoresDeuda != null) {
          me.arrayCobros = pagadoresDeuda;
        }
        me.condicion_cobros = 0; //0 productos y beneficio
      } else {
        if (pagadoresDeuda[0].pagadoresDeuda.length > 0)
          me.arrayCobros = pagadoresDeuda[0].pagadoresDeuda;
        //console.log(me.arrayCobros.length);
        me.condicion_cobros = 1; // 1 productosbeneficios
      }
      me.modalCobros = 1;
      me.indicePadreBenef = val;
      me.tituloModal = "Cobros!!";
      me.listaCodigos = "";

      //me.listarProveedores();
    },

    abrirModalMensajesPromo(val, idx, tip, mensj) {
      this.modalMensajes = 1;
      this.tituloModal = "Mensajes!!";
      this.condicion_mensajes = val; // 2  - 3 para editar en promociones - 4 vista previa
      this.idxMensajePromo = idx;
      this.tipoMensaje = tip;
      this.mensajePromo = mensj; //condicion_mensajes === 3
      this.mensajePromoVistaPrev = "";
      if (this.condicion_mensajes === 4) {
        this.condicion_mensajesVer = 1;
        this.condicion_mensajes = 3;
      } else {
        this.condicion_mensajesVer = 0;
      }
    },
    abrirModalCondiciones(casos_, situacion_cond, tipo_cond) {
      this.modalCondiciones = 1;
      this.tituloModal = "Registro de condiciones";
      this.casos_condiciones = casos_;

      this.tipoCondicionOY = tipo_cond;
      if (situacion_cond == 0) {
        // opcional
        this.mensajeCondicion = "Puede ser ";
        this.operadorCondiciones = "OR";
      } else {
        this.mensajeCondicion = "Y necesita de";
        this.operadorCondiciones = "AND";
      }

      if (this.casos_condiciones == 1) {
        this.casos_condicion = 11;
        this.tituloModal = "Condiciones de Promoción";
      }
    },
    abrirModalCondicionesProd(casos_, situacion_cond, tipo_cond) {
      if (
        this.arrayItem[this.indicePadre].condiciones.length === 0 &&
        situacion_cond === 1 &&
        casos_ === 21
      ) {
        this.$swal({
          //position: "top-end",
          title: "Recuerde",
          icon: "warning",
          text: "Primero debe seleccionar una opción del menú 'Opcional' de condiciones",
          //showConfirmButton: false,
          //timer: 2000,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      if (
        this.arrayItemBenef.length === 0 &&
        situacion_cond === 1 &&
        casos_ === 2
      ) {
        this.$swal({
          //position: "top-end",
          title: "Recuerde",
          icon: "warning",
          text: "Primero debe seleccionar una opción del menú 'Opcional' de Beneficios",
          //showConfirmButton: false,
          //timer: 2000,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      this.modalCondiciones = 1;
      this.listaCodigos = "";
      this.tituloModal = "Registro de condiciones";
      this.casos_condiciones = casos_; //1 condiciones 2 beneficios
      this.relacionAcumulacionCond = 1;
      this.acumulaCajasCondicion = true;
      //this.esAcumulableCondicion = true;
      this.cantidadCondicion = 0;
      this.limiteAplicacion = 0;
      this.limiteCanje = 0;
      this.cantidadBenef = 0;
      this.cambiarTipoAcumulacion();

      this.tipoCondicionOY = tipo_cond;
      if (situacion_cond == 0) {
        // opcional
        this.mensajeCondicion = "Puede ser ";
        this.operadorCondiciones = "OR";
      } else {
        this.mensajeCondicion = "Y necesita de";
        this.operadorCondiciones = "AND";
      }
      if (this.casos_condiciones == 1) {
        //condicoones
        this.casos_condicion = 11;
        this.tituloModal = "Condiciones de Promoción - Productos";
      }
      if (this.casos_condiciones == 2) {
        //beneficios - funcionando
        this.casos_condicion = 12;
        this.tituloModal = "Beneficios";
      }
      if (this.casos_condiciones == 20) {
        //productosbeneficios
        this.casos_condicion = 20;
        this.tituloModal = "Productos - Beneficios";
      }
      if (this.casos_condiciones == 21) {
        //productoscombinados - funcionando
        this.casos_condicion = 21;
        this.tituloModal = "Condición de productos";
      }
    },
    abrirModalCondicionesProdEdit(idx, hijo, padre, nodo) {
      //console.log("-->" + idx + "--" + hijo + " -- " + padre);
      //console.log(nodo);
      //console.log(nodo.tipo);
      //console.log(this.indicePadre);
      this.indiceHijoEdit = idx;
      this.acumulaCajasCondicion = nodo.acumulacionCajas;
      this.esAcumulableCondicion = nodo.acumulable;
      this.cantidadCondicion = nodo.cantidad;
      //this.productos.value = nodo.codigoProducto;
      this.listaCodigos = nodo.codigoProducto.toString();
      this.relacionAcumulacionCond = nodo.relacion;

      this.modalCondiciones = 1;
      this.tituloModal = "Registro de condiciones";
      this.casos_condiciones = 1; //1 condiciones 2 beneficios

      /*
      this.tipoCondicionOY = tipo_cond;
      if (situacion_cond == 0) {
        // opcional
        this.mensajeCondicion = "Puede ser ";
        this.operadorCondiciones = "OR";
      } else {
        this.mensajeCondicion = "Y necesita de";
        this.operadorCondiciones = "AND";
      }
      */
      if (this.casos_condiciones == 1) {
        //condicoones
        //this.casos_condicion = 15; //para editr productos
        this.casos_condicion = 16; //para editr productoscombinados
        this.tituloModal = "Condiciones de Promoción - Productos";
      }
    },
    abrirModalBeneficiosProdEdit(idx, nodo) {
      let me = this;
      me.modalCondiciones = 1;
      me.tituloModal = "Registro de Beneficios";
      me.casos_condicion = 1200; //para actualizar beneficios
      console.log("nodo: " + idx);
      me.indicePadreBeneficio = idx;
      me.limiteAplicacion = nodo.limiteAplicacion;
      me.limiteCanje = nodo.limiteCanje;
      me.cantidadBenef = nodo.cantidad;
      me.listaCodigos = nodo.codigoProducto.toString();
    },
    abrirModalProvLabSecCondicion(val, situacion_cond, tipo_cond) {
      if (
        this.arrayItem[this.indicePadre].condiciones.length === 0 &&
        situacion_cond === 1
      ) {
        this.$swal({
          //position: "top-end",
          title: "Recuerde",
          icon: "warning",
          text: "Primero debe seleccionar una opción del menú 'Opcional' de condiciones",
          //showConfirmButton: false,
          //timer: 2000,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      this.casos_condicion_btn = 0;
      this.tipoCondicionOY = tipo_cond;
      this.listaCodigos = "";

      if (situacion_cond == 0) {
        // opcional
        this.mensajeCondicion = "Puede ser ";
        this.operadorCondiciones = "OR";
      } else {
        this.mensajeCondicion = "Y necesita de ";
        this.operadorCondiciones = "AND";
      }

      if (val == 120) {
        //sucursal
        this.casos_condicion = 120; //casos_condicion === 120
        this.modalProvLabSec = 1;
        this.tituloModal = "Registro de Sucursal!!"; //se ve listar == 3
      }
      if (val == 121) {
        //Region
        this.casos_condicion = 121; //casos_condicion === 121
        this.modalProvLabSec = 1;
        this.tituloModal = "Registro de Región!!"; //se ve listar == 3
      }
      if (val == 122) {
        //Provincia
        this.casos_condicion = 122; //casos_condicion === 122
        this.modalProvLabSec = 1;
        this.tituloModal = "Registro de Provincia!!"; //se ve listar == 3
      }
      if (val == 123) {
        //Ciudad
        this.casos_condicion = 123; //casos_condicion === 123
        this.modalProvLabSec = 1;
        this.tituloModal = "Registro de Ciudad!!"; //se ve listar == 3
      }
      if (val == 124) {
        //Oficina
        this.casos_condicion = 124; //casos_condicion === 124
        this.modalProvLabSec = 1;
        this.tituloModal = "Registro de Oficina!!"; //se ve listar == 3
      }
      if (val == 125) {
        //segmentosClientes
        this.casos_condicion = 125; //casos_condicion === 125
        this.modalProvLabSec = 1;
        this.tituloModal = "Registro de Segmentos!!"; //se ve listar == 3
      }
    },
    abrirModalProvLabSecCondicionEdit(idx, hijo, padre, nodo) {
      let me = this;
      let val = 0;
      me.casos_condicion = 0;
      console.log("-->" + idx + "--" + hijo + " -- " + padre);
      console.log(nodo);
      me.indiceHijoEdit = idx;
      me.tipoCondicionOY = nodo.tipo;
      me.condicionAcumulacion = nodo.condicionAcumulacion;
      me.condicionCanje = nodo.condicionCanje;
      //this.cantidadCondicion=nodo.cantidad;
      /*this.tipoCondicionOY = tipo_cond;
      if (situacion_cond == 0) {
        // opcional
        this.mensajeCondicion = "Puede ser ";
        this.operadorCondiciones = "OR";
      } else {
        this.mensajeCondicion = "Y necesita de ";
        this.operadorCondiciones = "AND";
      }
      */
      if (me.tipoCondicionOY == "sucursal") {
        val = 120;
        me.listaCodigos = nodo.sucursal.toString();
      } else if (me.tipoCondicionOY == "region") {
        val = 121;
        me.listaCodigos = nodo.region.toString();
      } else if (me.tipoCondicionOY == "provincia") {
        val = 122;
        me.listaCodigos = nodo.provincia.toString();
      } else if (me.tipoCondicionOY == "ciudad") {
        val = 123;
        me.listaCodigos = nodo.ciudad.toString();
      } else if (me.tipoCondicionOY == "oficina") {
        val = 124;
        me.listaCodigos = nodo.oficina.toString();
      } else if (me.tipoCondicionOY == "segmentosClientes") {
        val = 125;
        me.segmento.value = nodo.segmento;
      }
      if (val == 120) {
        //sucursal
        me.casos_condicion_btn = 120; //casos_condicion_btn === 120
        me.modalProvLabSec = 1;
        me.tituloModal = "Registro de Sucursal!!"; //se ve listar == 3
      }
      if (val == 121) {
        //Region
        me.casos_condicion_btn = 121; //casos_condicion_btn === 121
        me.modalProvLabSec = 1;
        me.tituloModal = "Registro de Región!!"; //se ve listar == 3
      }
      if (val == 122) {
        //Provincia
        me.casos_condicion_btn = 122; //casos_condicion_btn === 122
        me.modalProvLabSec = 1;
        me.tituloModal = "Registro de Provincia!!"; //se ve listar == 3
      }
      if (val == 123) {
        //Ciudad
        me.casos_condicion_btn = 123; //casos_condicion_btn === 123
        me.modalProvLabSec = 1;
        me.tituloModal = "Registro de Ciudad!!"; //se ve listar == 3
      }
      if (val == 124) {
        //Oficina
        me.casos_condicion_btn = 124; //casos_condicion_btn === 124
        me.modalProvLabSec = 1;
        me.tituloModal = "Registro de Oficina!!"; //se ve listar == 3
      }
      if (val == 125) {
        //segmentosClientes
        me.casos_condicion_btn = 125; //casos_condicion_btn === 125
        me.modalProvLabSec = 1;
        me.tituloModal = "Registro de Segmentos!!"; //se ve listar == 3
      }
    },
    cerrarModal() {
      this.modalCabecera = 0;
      this.tituloModal = "";
      if (this.codigoPromocion === "") {
        this.listarPromociones(1, "buscar", "criterio", 1, "codigoPromocion");
        this.listar = 51;
      } else {
        this.verPromocion(this.codigoPromocion, 1);
      }
    },
    cerrarModalVi() {
      let me = this;
      me.listar = 51;
      me.aarray = [];
      me.arrayCondicionesProcess = [];
      me.arrayCondicionesProcessT = [];
      me.arrayBeneficiosProcess = [];
      me.arrayBeneficiosProcessT = [];
      me.arrayOficinasProcess = [];
      me.arrayOficinasProcessT = [];
      me.arraySucursalesProcess = [];
      me.buscarOficinaLk = "";
      me.buscarCondicionesLk = "";
      me.buscarBeneficiosLk = "";
      me.statusConfig = 0;
    },
    cerrarModalCondiciones() {
      this.modalCondiciones = 0;
      this.btnfinalizarR = 1;
      this.tituloModal = "";
      this.buscarPromocion();
    },
    cerrarModalProvLabSec() {
      this.modalProvLabSec = 0;
      this.tituloModal = "";
      //this.buscarPromocion();
    },
    cerrarModalMensajes() {
      this.modalMensajes = 0;
    },
    cerrarModalCobros() {
      this.modalCobros = 0;
    },
    cerrarModalVistaPrevia() {
      this.modalVistaPrevia = 0;
    },
    cerrarModalExtensionCancel() {
      this.modalExtension = 0;
      this.controlExtension = 0;
      this.controlExtensionCancel = 0;
    },

    solicitarMensajesPromo() {
      let me = this;

      me.$swal({
        position: "top-end",
        title: "Está seguro de cargar la plantilla de mensajes",
        text: "¡Confirmar!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          me.arrayMensajesPromocionTipos = [];
          me.arrayMensajesPromocion = [];
          var url = me.http_ + "/acumulacion/mf/mensajes/searchOne";
          axios
            .get(url)
            .then(function (response) {
              //console.log(response);
              var respuesta = response.data;
              me.arrayMensajesPromocion.push({
                descripcion: respuesta.descripcion,
                estado: respuesta.estado,
                tipoMensaje: respuesta.tipoMensaje,
              });
              //me.arrayMensajesPromocion = response.data;

              me.arrayMensajesPromocionTipos =
                me.arrayMensajesPromocion[0].tipoMensaje;
              console.log(me.arrayMensajesPromocionTipos);
              me.actualizarEncabezdoPromocion();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    selectTipoCondicion() {
      let me = this;

      var url = me.http_ + "/acumulacion/mf/tipocondiciones/all";
      axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          //var respuesta = response.data;
          me.arrayTipoCondiciones = response.data;
          //console.log(me.arrayTipoCondiciones);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onSelectTipoCondicion() {
      let me = this;
      //console.log(me.condiciones_id);
      //me.listarMostrarCondicion=0;
      me.tipoCondicion = me.condiciones_id;
      if (me.condiciones_id == "Producto") {
        console.log(me.condiciones_id);
        //me.listarMostrarCondicion=1;
        //me.tipoCondicion='Producto';
      }
      if (me.condiciones_id == "Precio") {
        console.log(me.condiciones_id);
        //me.listarMostrarCondicion=2;
      }
      if (me.condiciones_id == "Region") {
        console.log(me.condiciones_id);
        //me.listarMostrarCondicion=3;
      }
    },
    actualuzarFechaInicioPromo(val_f) {
      let me = this;
      if (val_f === 1) {
        me.fechaInicioAcumulacion = me.fechaInicio;
        if (me.fechaFin.valueOf() <= me.fechaInicio.valueOf()) {
          me.compararFecha = 1;
          me.fechaFin = "";
        } else {
          me.compararFecha = 0;
        }
      } else {
        if (me.fechaFin.valueOf() <= me.fechaFinTemporal.valueOf()) {
          me.compararFecha = 1;
          me.fechaFin = "";
        } else {
          me.compararFecha = 0;
        }
      }
    },
    verificarExistenciaPromocionNombre() {
      let me = this;
      var existe;
      //var url = me.http_+"/acumulacion/mf/promociones/exists/"+me.codigoPromocion+"";
      //axios.get(url).then(function (response) {
      PromoService.getExistsName(me.nombrePromocion)
        .then((response) => {
          //console.log(response);
          //let respuesta = response.data;
          console.log(response.data);
          existe = Boolean(response.data);
          if (existe) {
            me.existePromocion = 1;
            me.nombrePromocion = "";
          } else {
            me.existePromocion = 0;
          }
          //me.mecanica=me.nombrePromocion;
          //console.log(me.existePromocion);
        })
        .catch(function (error) {
          console.log(error);
        });
      console.log(me.existePromocion);
    },
    validarPromocion() {
      let me = this;
      me.errorPromoLgth = 0;
      me.errorMostrarMsjPromo = [];
      if (me.fechaInicio.length < 2) me.fechaInicio = "";
      if (me.fechaFin.length < 2) me.fechaFin = "";
      if (me.fechaInicioAcumulacion.length < 2) me.fechaInicioAcumulacion = "";

      if (!me.nombrePromocion)
        me.errorMostrarMsjPromo.push("Ingresar nombre de la promoción");
      if (!me.nombreCRM) me.errorMostrarMsjPromo.push("Ingresar nombre CRM");
      /*
      if (!me.observacionesPromocion)
        me.errorMostrarMsjPromo.push("Ingresar Descripción de la promoción");
      */
      if (me.fechaInicio.length < 2)
        me.errorMostrarMsjPromo.push("Ingresar fecha de incio");
      if (me.fechaFin.length < 2)
        me.errorMostrarMsjPromo.push("Ingresar fecha de fin");

      //if (me.mecanicaValor < 1)
      //me.errorMostrarMsjPromo.push("Ingresar Mecánica de la promoción");
      //if (me.mecanicaBonificacion < 1)
      //me.errorMostrarMsjPromo.push("Ingresar Mecánica bonficación de la promoción");
      if (!me.mecanica)
        me.errorMostrarMsjPromo.push("Ingresar descripción de la mecánica");
      if (me.periodoCanje == 0)
        me.errorMostrarMsjPromo.push("Ingresar período canje ");
      if (me.responsablePromo.length < 2)
        me.errorMostrarMsjPromo.push("Seleccione responsable");
      if (me.lineaCSolicitante.length < 2)
        me.errorMostrarMsjPromo.push("Seleccione línea comercial");

      /*
      if (me.mesPendienteCanje <= 0 )
        me.errorMostrarMsjPromo.push("Ingresar Meses pendiente caje de de promoción");
      */

      if (me.errorMostrarMsjPromo.length) {
        me.errorPromoLgth = 1;
        /*
        me.$swal({
          position: "top-end",
          icon: "warning",
          title: me.errorMostrarMsjPromo,
          showConfirmButton: false,
          timer: 1000,
        });*/
        me.$swal({
          title: "Completar los campos",
          text: me.errorMostrarMsjPromo,
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
      return me.errorPromoLgth;
    },
    activarEditar() {
      let me = this;
      if (me.estado_proceso === 1) {
        me.btnfinalizarR = 1;
        me.casos = 51;
      } else {
        me.btnfinalizarR = 0;
        me.casos = 0;
      }
    },
    verPromocion(valor, conVerEdit) {
      let me = this;
      console.log("Ver promocion" + valor);
      //me.nuevaPromocion();
      me.listar = 3;
      me.estado_proceso = conVerEdit;

      //var url = me.http_ + "/acumulacion/mf/promociones/searchOne/" + valor;
      //var url = "http://192.168.236.242:9003/processDocs?getPromoInfo=" + valor;
      var url = IPServie.getURLAPIEXT() + "/processDocs?getPromoInfo=" + valor;
      console.log(url);

      /**
       * ,
      {
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin":'*',
          "Access-Control-Allow-Methods": "GET, POST",
        }
      }
       */

      axios
        .get(
          url
          /*
       {
        headers:{
          'Accept': 'application/json;charset=UTF-8',
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin":'*',
          "Access-Control-Allow-Methods": "GET, POST",
        },data:{}
      }
      */
        )
        .then(function (response) {
          console.log(response);
          var respuesta = response.data;
          me.codigoPromocion = respuesta.codigoPromocion;
          me.nombrePromocion = respuesta.nombre;
          me.observacionesPromocion = respuesta.observaciones;
          me.nombreCRM = respuesta.nombreCRM;
          me.mecanica = respuesta.mecanica;
          me.periodoCanje = respuesta.periodoCanje;
          //me.unidadPeriodoCanje = respuesta.unidadPeriodoCanje;
          me.mesPendienteCanje = respuesta.mesPendienteCanje;
          me.acumulacionCajas = respuesta.acumulacionCajas;
          me.tipoAcumulacion = respuesta.tipoAcumulacion;
          me.tipoMF = respuesta.tipoMF;
          me.estadoPromocion = respuesta.estado;
          me.responsablePromo = respuesta.responsable;
          me.lineaCSolicitante = respuesta.lineaCSolicitante;
          me.generaCobro = respuesta.generaCobro;
          me.asumeCategoria = respuesta.asumeCategoria;
          me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion;
          //me.existePromocion = respuesta.nombre;
          //me.mensaje = respuesta.nombre;
          me.arrayItem = respuesta.grupoCondiciones;
          me.arrayItemBenef = respuesta.beneficio;
          //me.mecanicaValor = respuesta.mecanicaValor;
          //me.mecanicaBonificacion = respuesta.mecanicaBonificacion;

          me.fechaInicio = respuesta.fechaInicio;
          me.fechaFin = respuesta.fechaFin;
          //me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion;
          //me.fechaInicio = respuesta.fechaInicio.substring(0, 10) +
          //  "T" +respuesta.fechaInicio.substring(11, 16);
          //me.fechaFin = respuesta.fechaFin.substring(0, 10) +
          //  "T" +respuesta.fechaFin.substring(11, 16);
          //me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion.substring(0, 10) +
          //  "T" +respuesta.fechaInicioAcumulacion.substring(11, 16);;

          //me.fecha =arrayVentaT[0]["fecha_hora"].substring(0, 10)+"T" + arrayVentaT[0]["fecha_hora"].substring(11, 16);

          //me.mensajePromo = respuesta.mensajePromo;
          me.arrayMensajesPromocion = respuesta.mensajes;

          //me.cantidadCondicion = me.mecanicaValor;
          //me.cantidadBenef = me.mecanicaBonificacion;
          (me.usuario = respuesta.usuario),
            (me.usuarioModifica = respuesta.usuarioModifica);
          me.fechaRegistro = respuesta.fechaRegistro;
          me.fechaUltimoCambio = respuesta.fechaUltimoCambio;

          me.arrayMensajesPromocionTipos =
            me.arrayMensajesPromocion[0].tipoMensaje;
          //
          if (me.estado_proceso === 1 && me.estadoPromocion === "Activo") {
            me.estado_procesoCabecera = 1;
            me.estado_proceso = -1;
          } else {
            me.estado_procesoCabecera = 0;
          }
          me.activarEditar();
          //para listar condiciones-beneficios
          me.arrayBeneficiosProcessT = respuesta.pvBenedicios.grupoBeneficios;
          me.arrayBeneficiosProcess = respuesta.pvBenedicios.grupoBeneficios;
          //me.arrayCondicionesProcess = respuesta.jvarCondiciones;
          //me.arrayCondicionesProcessT = respuesta.jvarCondiciones;
          me.arrayCondicionesProcess = respuesta.jvarCondicionesPro;
          me.arrayCondicionesProcessT = respuesta.jvarCondicionesPro;

          console.log(me.arrayCondicionesProcessT);
          me.arrayOficinasProcessT = respuesta.oficinas;
          me.arrayOficinasProcess = me.arrayOficinasProcessT;
          me.procesarSucursales();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    procesarSucursales() {
      let me = this;
      let arrayTempO = [];
      let arrayFilter = [];
      let oficinaTx = "";
      let totalS = 0;
      let idSucursal = "";
      let sucursales = ["002", "003", "004", "009", "010", "012", "014", "015"];
      for (let j = 0; j < sucursales.length; j++) {
        totalS = 0;
        for (let i = 0; i < me.arrayOficinasProcess.length; i++) {
          //oficinaTx = me.arrayOficinasProcess[i].nombre_oficina;
          idSucursal = me.arrayOficinasProcess[i].sucursal;
          //console.log(oficinaTx.indexOf(me.buscarOficinaLk)+" --> "+ i+". "+oficinaTx);
          //console.log(sucursales[j]+".."+idSucursal);
          if (sucursales[j] == idSucursal) {
            oficinaTx = me.arrayOficinasProcess[i].nombre_sucursal;
            totalS++;
            //console.log(totalS);
          }
        }
        me.arraySucursalesProcess.push({
          Codigo: sucursales[j],
          Sucursal: oficinaTx,
          Oficinas: totalS,
        });
      }
      console.log(me.arraySucursalesProcess);
    },
    buscarBeneficiosLike() {
      let me = this;
      let arrayTempC = [];
      let arrayFilter = [];
      let arrayOpciones = [];
      let textoTx = "";
      arrayTempC = me.arrayBeneficiosProcessT;
      //console.log(me.buscarCondicionesLk);
      if (me.buscarBeneficiosLk != "") {
        for (let i = 0; i < arrayTempC.length; i++) {
          arrayOpciones = arrayTempC[i].beneficios;
          console.log(arrayOpciones);
          for (let j = 0; j < arrayOpciones.length; j++) {
            //textoTx = arrayOpciones[j].detalleProducto;
            //console.log(textoTx.indexOf(me.buscarCondicionesLk)+" --> "+ j+". "+textoTx);
            //if (me.selectCodDesB == 0) {
            textoTx = arrayOpciones[j].codigoProducto;
            //} if(me.selectCodDesB == 1) {

            let textoTxDes = arrayOpciones[j].detalleProducto;
            //}

            if (
              textoTx.indexOf(me.buscarBeneficiosLk) != -1 ||
              textoTxDes.indexOf(me.buscarBeneficiosLk.toUpperCase()) != -1
            ) {
              //console.log(i+":"+textoTx);
              arrayFilter.push({ beneficios: arrayOpciones });
              j = arrayOpciones.length;
            } else {
              //console.log(i+":"+arrayTempO[i].nombre_oficina);
            }
          }
        }
        //console.log(arrayFilter);
        me.arrayBeneficiosProcess = arrayFilter;
        //console.log(me.arrayCondicionesProcess);
      } else {
        me.arrayBeneficiosProcess = me.arrayBeneficiosProcessT;
      }
    },
    buscarCondicionesLike() {
      let me = this;
      let arrayTempC = [];
      let arrayFilter = [];
      let arrayOpciones = [];
      let textoTx = "";
      arrayTempC = me.arrayCondicionesProcessT;
      //console.log(me.buscarCondicionesLk);
      if (me.buscarCondicionesLk != "") {
        for (let i = 0; i < arrayTempC.length; i++) {
          arrayOpciones = arrayTempC[i].cod;
          //console.log(arrayOpciones);
          for (let j = 0; j < arrayOpciones.length; j++) {
            //textoTx = arrayOpciones[j].descripcionProducto;
            //console.log(textoTx.indexOf(me.buscarCondicionesLk)+" --> "+ j+". "+textoTx);
            //if (me.selectCodDesC == 0) {
            textoTx = arrayOpciones[j].codigoProducto;
            //} else {
            let textoTxDes = arrayOpciones[j].descripcionProducto;
            //}

            if (
              textoTx.indexOf(me.buscarCondicionesLk) != -1 ||
              textoTxDes.indexOf(me.buscarCondicionesLk.toUpperCase()) != -1
            ) {
              console.log(i + ":" + textoTx);
              arrayFilter.push({ cod: arrayOpciones });
            } else {
              //console.log(i+":"+arrayTempO[i].nombre_oficina);
            }
          }
        }
        console.log(arrayFilter);
        me.arrayCondicionesProcess = arrayFilter;
        //console.log(me.arrayCondicionesProcess);
      } else {
        me.arrayCondicionesProcess = me.arrayCondicionesProcessT;
      }
    },
    buscarOficinaLike() {
      let me = this;
      let arrayTempO = [];
      let arrayFilter = [];
      let oficinaTx = "";
      arrayTempO = me.arrayOficinasProcessT;
      console.log(me.buscarOficinaLk);
      if (me.buscarOficinaLk != "") {
        for (let i = 0; i < arrayTempO.length; i++) {
          //if (me.selectCodDesO == 0) {
            oficinaTx = arrayTempO[i]._id;
          //} else {
            let oficinaTxDes = arrayTempO[i].nombre_oficina;
          //}
          //console.log(oficinaTx.indexOf(me.buscarOficinaLk)+" --> "+ i+". "+oficinaTx);
          if ((oficinaTx.indexOf(me.buscarOficinaLk) != -1) || (oficinaTxDes.indexOf(me.buscarOficinaLk.toUpperCase()) != -1)) {
            //console.log(i+":"+oficinaTx);
            arrayFilter.push(arrayTempO[i]);
          } else {
            //console.log(i+":"+arrayTempO[i].nombre_oficina);
          }
        }
        me.arrayOficinasProcess = arrayFilter;
      } else {
        me.arrayOficinasProcess = me.arrayOficinasProcessT;
      }
    },
    verConfiguracion() {
      let me = this;
      if (me.statusConfig == 0) {
        me.statusConfig = 1;
      } else {
        me.statusConfig = 0;
      }
    },
    registrarPromocion() {
      let me = this;

      if (me.validarPromocion()) {
        return;
      }
      if (me.mesPendienteCanje > 0) {
        //me.fechaInicioAcumulacion = "";
      }
      if (!me.noAplicaFIAC) {
        me.fechaInicioAcumulacion = "";
      }
      if (me.tipoMF === "Tratamiento Completo") {
        me.mesPendienteCanje = 1;
      }

      axios
        .post(me.http_ + "/acumulacion/mf/promociones/save", {
          //codigoPromocion: me.codigoPromocion,
          codigoPadre: "",
          nombre: me.nombrePromocion.toUpperCase(),
          observaciones: me.observacionesPromocion.toUpperCase(),
          nombreCRM: me.nombreCRM.toUpperCase(),
          fechaInicio: me.fechaInicio.replace("T", " "),
          fechaFin: me.fechaFin.replace("T", " "),
          mecanica: me.mecanica.toUpperCase(),
          periodoCanje: me.periodoCanje,
          mesPendienteCanje: me.mesPendienteCanje,
          tipoAcumulacion: me.tipoAcumulacion,
          tipoMF: me.tipoMF,
          estado: me.estadoPromocion,
          acumulacionCajas: me.acumulacionCajas,
          fechaInicioAcumulacion: me.fechaInicioAcumulacion.replace("T", " "),
          responsable: me.responsablePromo,
          generaCobro: me.generaCobro,
          asumeCategoria: me.asumeCategoria,
          //mecanicaValor: me.mecanicaValor,
          //mecanicaBonificacion: me.mecanicaBonificacion,
          lineaCSolicitante: me.lineaCSolicitante,

          grupoCondiciones: me.grupoCondiciones,
          beneficio: me.arrayBeneficios,
          mensaje: me.mensaje + " " + me.codigoPromocion,
          //mensajePromo: me.mensajePromo,
          mensajes: me.arrayMensajesPromocion,
          // datos
          usuario: me.usuario,
          usuarioModifica: me.usuarioModifica,
          fechaRegistro: FechaService.fechaHoy(),
          fechaUltimoCambio: FechaService.fechaHoy(),
        })
        .then(function (response) {
          var respuesta = response.data;
          //console.log(respuesta);
          me.codigoPromocion = respuesta.codigoPromocion;
          me.nombrePromocion = respuesta.nombre;
          me.observacionesPromocion = respuesta.observaciones;
          me.nombreCRM = respuesta.nombreCRM;
          me.fechaInicio = respuesta.fechaInicio;
          me.fechaFin = respuesta.fechaFin;
          me.mecanica = respuesta.mecanica;
          me.periodoCanje = respuesta.periodoCanje;
          //me.unidadPeriodoCanje = respuesta.unidadPeriodoCanje;
          me.mesPendienteCanje = respuesta.mesPendienteCanje;
          me.acumulacionCajas = respuesta.acumulacionCajas;
          me.tipoAcumulacion = respuesta.tipoAcumulacion;
          me.tipoMF = respuesta.tipoMF;
          me.estadoPromocion = respuesta.estado;
          me.responsablePromo = respuesta.responsable;
          me.generaCobro = respuesta.generaCobro;
          me.asumeCategoria = respuesta.asumeCategoria;
          me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion;
          me.lineaCSolicitante = respuesta.lineaCSolicitante;
          //me.mensajePromo = respuesta.mensajePromo;
          me.arrayMensajesPromocion = respuesta.mensajes;
          (me.usuario = respuesta.usuario),
            (me.usuarioModifica = respuesta.usuarioModifica);
          me.fechaRegistro = respuesta.fechaRegistro;
          me.fechaUltimoCambio = respuesta.fechaUltimoCambio;
          //me.existePromocion = respuesta.nombre;
          //me.mensaje = respuesta.nombre;
          //console.log("NOM...   " + me.nombrePromocion);
          me.cerrarModal();
          //me.cantidadCondicion = me.mecanicaValor;
          //me.cantidadBenef = me.mecanicaBonificacion;
          me.showAlert(1);
          me.estado_proceso = 1;

          if (me.arrayItem.length < 1) {
            me.asignarPadre();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    actualizarEncabezdoPromocion() {
      let me = this;
      if (me.validarPromocion()) {
        return;
      }
      //console.log();
      if (me.arrayItem.length > 0) {
        me.arrayItem = PromoService.getValCondNoAcumulable(
          me.arrayItem,
          me.tipoMF
        );
        me.grupoCondiciones = me.arrayItem;
        me.registrarPromocionCondiciones();
      }

      if (me.mesPendienteCanje > 0) {
        //me.fechaInicioAcumulacion = "";
      }
      if (!me.noAplicaFIAC) {
        me.fechaInicioAcumulacion = "";
      }
      me.usuarioModifica = localStorage.getItem("user");
      if (me.tipoMF === "Tratamiento Completo") {
        me.mesPendienteCanje = 1;
      }

      console.log(me.fechaInicioAcumulacion);
      axios
        .post(me.http_ + "/acumulacion/mf/promociones/updatePromociones", {
          codigoPromocion: me.codigoPromocion,
          codigoPadre: "",
          nombre: me.nombrePromocion.toUpperCase(),
          observaciones: me.observacionesPromocion.toUpperCase(),
          nombreCRM: me.nombreCRM.toUpperCase(),
          fechaInicio: me.fechaInicio.replace("T", " "),
          fechaFin: me.fechaFin.replace("T", " "),
          mecanica: me.mecanica.toUpperCase(),
          periodoCanje: me.periodoCanje,
          mesPendienteCanje: me.mesPendienteCanje,
          tipoAcumulacion: me.tipoAcumulacion,
          tipoMF: me.tipoMF,
          estado: me.estadoPromocion,
          acumulacionCajas: me.acumulacionCajas,
          responsable: me.responsablePromo,
          generaCobro: me.generaCobro,
          asumeCategoria: me.asumeCategoria,
          fechaInicioAcumulacion: me.fechaInicioAcumulacion.replace("T", " "),
          //mecanicaValor: me.mecanicaValor,
          //mecanicaBonificacion: me.mecanicaBonificacion,
          lineaCSolicitante: me.lineaCSolicitante,
          //grupoCondiciones: me.grupoCondiciones,
          //beneficio: me.arrayBeneficios,
          //mensaje: me.mensaje + " " + me.codigoPromocion,
          //mensajePromo: me.mensajePromo,
          mensajes: me.arrayMensajesPromocion,
          usuarioModifica: me.usuarioModifica,
          fechaUltimoCambio: FechaService.fechaHoy(),
        })
        .then(function (response) {
          var respuesta = response.data;
          //console.log(respuesta);
          me.codigoPromocion = respuesta.codigoPromocion;
          me.nombrePromocion = respuesta.nombre;
          me.observacionesPromocion = respuesta.observaciones;
          me.nombreCRM = respuesta.nombreCRM;
          me.fechaInicio = respuesta.fechaInicio;
          me.fechaFin = respuesta.fechaFin;
          me.mecanica = respuesta.mecanica;
          me.periodoCanje = respuesta.periodoCanje;
          //me.unidadPeriodoCanje = respuesta.unidadPeriodoCanje;
          me.mesPendienteCanje = respuesta.mesPendienteCanje;
          me.acumulacionCajas = respuesta.acumulacionCajas;
          me.tipoAcumulacion = respuesta.tipoAcumulacion;
          me.tipoMF = respuesta.tipoMF;
          me.estadoPromocion = respuesta.estado;
          me.responsablePromo = respuesta.responsable;
          me.generaCobro = respuesta.generaCobro;
          me.asumeCategoria = respuesta.asumeCategoria;
          me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion;
          me.lineaCSolicitante = respuesta.lineaCSolicitante;
          //me.mensajePromo = respuesta.mensajePromo;
          me.arrayMensajesPromocion = respuesta.mensajes;
          (me.usuario = respuesta.usuario),
            (me.usuarioModifica = respuesta.usuarioModifica);
          me.fechaRegistro = respuesta.fechaRegistro;
          me.fechaUltimoCambio = respuesta.fechaUltimoCambio;
          //me.existePromocion = respuesta.nombre;
          //me.mensaje = respuesta.nombre;
          me.cerrarModal();
          //me.cantidadCondicion = me.mecanicaValor;
          //me.cantidadBenef = me.mecanicaBonificacion;
          me.showAlert(1);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showAlert(valr) {
      if (valr == 1) {
        this.$swal({
          position: "top-end",
          icon: "success",
          title: "Registro guardado",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    registrarPromocionCondiciones() {
      let me = this;
      axios
        .post(me.http_ + "/acumulacion/mf/promociones/saveCondiciones", {
          codigoPromocion: me.codigoPromocion,
          grupoCondiciones: me.grupoCondiciones,
          usuarioModifica: me.usuarioModifica,
          fechaUltimoCambio: FechaService.fechaHoy(),
        })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    registrarPromocionBeneficios() {
      let me = this;
      me.usuarioModifica = localStorage.getItem("user");
      axios
        .post(me.http_ + "/acumulacion/mf/promociones/saveBeneficios", {
          codigoPromocion: me.codigoPromocion,
          beneficio: me.arrayBeneficios,
          usuarioModifica: me.usuarioModifica,
          fechaUltimoCambio: FechaService.fechaHoy(),
        })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    buscarPromocion() {
      let me = this;
      var url =
        me.http_ +
        "/acumulacion/mf/promociones/searchOne/" +
        me.codigoPromocion;
      axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          //var respuesta = response.data;
          me.arrayGrupoCondiciones = response.data;
          me.arrayGrupoCondiciones = me.arrayGrupoCondiciones.grupoCondiciones;
          //console.log(me.arrayGrupoCondiciones.grupoCondiciones);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    nuevaPromocion() {
      let me = this;
      me.listar = 3;

      me.codigoPromocion = "";
      me.nombrePromocion = "";
      me.observacionesPromocion = "";
      me.nombreCRM = "";
      me.fechaInicio = FechaService.fechaHoy();
      me.fechaInicio = me.fechaInicio.substring(0, 10) + "T00:00"; //+me.fechaInicio.substring(11,16);
      me.fechaInicioSistema = FechaService.fechaHoy();
      me.fechaInicioSistema = me.fechaInicioSistema.substring(0, 10) + "T00:00"; //+me.fechaInicioSistema.substring(11,16);
      me.fechaFin = me.fechaInicioSistema.substring(0, 10) + "T23:59";
      me.mecanica = "";
      me.periodoCanje = "0";
      me.mesPendienteCanje = "1";
      me.tipoAcumulacion = "Acumulable";
      me.tipoMF = "Medicación Frecuente";
      me.estadoPromocion = "Pendiente";
      me.acumulacionCajas = true;
      me.grupoCondiciones = [];
      me.arrayBeneficios = [];
      me.mensaje = "";
      me.arrayCondicionesAceptadas = [];
      me.nombreGrupo = "A";
      me.codigoGrupo = "";
      me.operadorGrupo = "OR";
      me.arrayItem = [];
      me.arrayItemBenef = [];
      me.mecanicaValor = 0;
      me.mecanicaBonificacion = 0;
      me.fechaInicioAcumulacion = "01/01/2021 00:00";
      me.btnfinalizarR = 0;
      me.compararFecha = 0;
      me.responsablePromo = "0";
      me.generaCobro = "SI";
      me.asumeCategoria = "NO";
      me.lineaCSolicitante = "0";

      me.arrayMensajesPromocion = [];
      me.arrayMensajesPromocionTipos = [];
      //me.estado_proceso=0;
    },

    listarPromociones(pagina_, buscar_, criterio_, ascdesc, descOrdenacion) {
      let me = this;
      me.arrayPromocionesAll = [];
      //pagina_ = 1;
      if (buscar_ == "") {
        buscar_ = "buscar";
      }
      if (criterio_ == "") {
        criterio_ = "criterio";
      }
      //console.log("Buscar:"+buscar_+"Cirterio: "+criterio_);
      console.log("Lista de promociones:" + ascdesc);

      var url =
        me.http_ +
        "/API/promociones/searchAll/" +
        pagina_ +
        "/" +
        buscar_ +
        "/" +
        criterio_ +
        "/" +
        ascdesc +
        "/" +
        descOrdenacion;
      //var url = me.http_ + "/acumulacion/mf/promociones/all";

      console.log(url);
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //var respuesta = response.data;
          //me.arrayPromocionesAll = response.data.data;
          me.paginasTotal = response.data.total;
          me.arrayPromocionesAll_all = response.data.todo;
          me.arrayPromocionesAll = response.data.todo;
          me.arrayPromocionesAll_pag = response.data.todo;
          console.log(me.arrayPromocionesAll_all.length);
          me.paginasTotal = Math.ceil(
            me.arrayPromocionesAll_all.length / me.obj_per_page
          );
          me.arrayPromocionesAll_ES = response.data.todo;
          me.arrayPromocionesAll_MD = response.data.todo;
          //console.log(me.paginasTotal);
          me.fitrarPromociones(1);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarPromocionesLike(val) {
      let me = this;

      me.controlPaginas = 1;
      var url = "";
      var buscar2_ = "",
        buscar3_ = "",
        buscar4_ = "";
      var criterio2_ = "",
        criterio3_ = "",
        criterio4_ = "";
      let controlCodigo = 0;
      me.controlBusqueda = 0;
      me.arrayPromocionesAll = [];
      if (val == 1) {
        me.paginaActiva = 1;
      }
      if (val == 3) {
        me.buscar2 = "";
        me.buscar3 = "Estado";
        me.buscar4 = "0";
        me.controlBusqueda = 0;
      }
      if (me.buscar != "") {
        controlCodigo = 1;
      }
      if (me.buscar2 == "" && me.buscar3 == "" && me.buscar4 == "0") {
        //000
        me.controlBusqueda = 0;
      }
      if (me.buscar2 != "" && me.buscar3 != "" && me.buscar4 == "0") {
        //110
        me.controlBusqueda = 1;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
        buscar3_ = me.buscar3;
        criterio3_ = me.criterio3;
      }
      if (me.buscar2 != "" && me.buscar3 == "Estado" && me.buscar4 != "0") {
        //101
        me.controlBusqueda = 2;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
        buscar3_ = me.buscar4;
        criterio3_ = me.criterio4;
      }
      if (me.buscar2 != "" && me.buscar3 == "Estado" && me.buscar4 == "0") {
        //100
        me.controlBusqueda = 3;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
      }
      if (me.buscar2 == "" && me.buscar3 != "Estado" && me.buscar4 != "0") {
        //011
        me.controlBusqueda = 4;
        buscar2_ = me.buscar3;
        criterio2_ = me.criterio3;
        buscar3_ = me.buscar4;
        criterio3_ = me.criterio4;
      }
      if (me.buscar2 == "" && me.buscar3 != "Estado" && me.buscar4 == "0") {
        //010
        me.controlBusqueda = 5;
        buscar2_ = me.buscar3;
        criterio2_ = me.criterio3;
      }
      if (me.buscar2 == "" && me.buscar3 == "Estado" && me.buscar4 != "0") {
        //001
        me.controlBusqueda = 6;
        buscar2_ = me.buscar4;
        criterio2_ = me.criterio4;
      }
      if (me.buscar2 != "" && me.buscar3 != "Estado" && me.buscar4 != "0") {
        //111
        me.controlBusqueda = 7;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
        buscar3_ = me.buscar3;
        criterio3_ = me.criterio3;
        buscar4_ = me.buscar4;
        criterio4_ = me.criterio4;
      }

      ////////console.log("Buscar:"+buscar_+"Cirterio: "+criterio_);
      console.log("Lista de promociones");
      if (me.controlBusqueda == 0 && controlCodigo == 0) {
        console.log("Ingr1");
        url =
          me.http_ +
          "/API/promociones/searchAll/" +
          me.paginaActiva +
          "/buscar/criterio/1/codigoPromocion";
      }
      if (me.controlBusqueda == 0 && controlCodigo == 1) {
        console.log("Ingr2");
        url = me.http_ + "/API/promociones/searchOneList/" + me.buscar;
      }
      if (
        me.controlBusqueda == 1 ||
        me.controlBusqueda == 2 ||
        me.controlBusqueda == 4
      ) {
        console.log("Ingr3");
        url =
          me.http_ +
          "/API/promociones/searchAllDos/" +
          me.paginaActiva +
          "/" +
          buscar2_ +
          "/" +
          criterio2_ +
          "/" +
          buscar3_ +
          "/" +
          criterio3_;
      }
      if (
        me.controlBusqueda == 3 ||
        me.controlBusqueda == 5 ||
        me.controlBusqueda == 6
      ) {
        console.log("Ingr4:" + me.controlBusqueda);
        url =
          me.http_ +
          "/API/promociones/searchAll/" +
          me.paginaActiva +
          "/" +
          buscar2_ +
          "/" +
          criterio2_ +
          "/1/codigoPromocion";
      }
      if (me.controlBusqueda == 7) {
        console.log("Ingr5");
        url =
          me.http_ +
          "/API/promociones/searchAllTres/" +
          me.paginaActiva +
          "/" +
          buscar2_ +
          "/" +
          criterio2_ +
          "/" +
          buscar3_ +
          "/" +
          criterio3_ +
          "/" +
          buscar4_ +
          "/" +
          criterio4_;
      }
      console.log(url);
      //var url = me.http_ + "/acumulacion/mf/promociones/all";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //var respuesta = response.data;
          me.arrayPromocionesAll = response.data.data;
          me.paginasTotal = response.data.total;
          console.log(me.arrayPromocionesAll);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    validarFinalizacion() {
      let me = this;
      let arrayMensajesVF = [];
      //let arrayCondi=[];
      //let arrayBenefCb=[];
      let errorPromoVF = 0;
      if (me.fechaInicio.length < 2)
        arrayMensajesVF.push("Revise la fecha incio ");
      if (me.fechaFin.length < 2) arrayMensajesVF.push("Revise la fecha fin ");
      if (me.arrayItem.length > 0) {
        for (var i = 0; i < me.arrayItem.length; i++) {
          //arrayCondi = [];
          //arrayCondi = me.arrayItem[i].condiciones;
          if (me.arrayItem[i].condiciones.length == 0) {
            arrayMensajesVF.push(
              "Los grupos de condiciones deben tener condiciones "
            );
          }
        }
      } else {
        arrayMensajesVF.push("La promoción debe tener condiciones ");
      }
      console.log(me.arrayItemBenef.length);
      if (me.arrayItemBenef.length > 0) {
        for (var j = 0; j < me.arrayItemBenef.length; j++) {
          //arrayBenefCb =  me.arrayItemBenef[j].pagadoresDeuda;
          if (me.arrayItemBenef[j].pagadoresDeuda.length == 0) {
            arrayMensajesVF.push("Los beneficios deben tener cobros ");
          }
        }
      } else {
        arrayMensajesVF.push("La promoción debe tener beneficios ");
      }
      if (me.arrayMensajesPromocion.length > 0) {
        if (me.arrayMensajesPromocion[0].tipoMensaje.length == 0)
          arrayMensajesVF.push("La promoción debe tener mensajes. ");
      } else {
        arrayMensajesVF.push("La promoción debe tener mensajes ");
      }
      me.$swal({
        title: "Completar la información",
        text: arrayMensajesVF,
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      });
      if (arrayMensajesVF.length) {
        errorPromoVF = 1;
      }
      console.log(arrayMensajesVF);
      return errorPromoVF;
    },

    finalizarPromocion() {
      let me = this;
      if (me.validarPromocion()) {
        return;
      }
      if (me.validarFinalizacion()) {
        return;
      }
      console.log("Finalizar promocion" + me.codigoPromocion);

      me.$swal({
        position: "top-end",
        title:
          "Está seguro de Activar la promoción " +
          me.codigoPromocion +
          " para despliegue?. ",
        text: "¡No podrá revertir proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          me.$swal({
            //'Duplicados!','Promociones duplicadas.', 'success'
            position: "top-end",
            icon: "success",
            title: "Promoción Activa para despliegue.",
            showConfirmButton: false,
            timer: 1000,
          });
          var url =
            me.http_ +
            "/acumulacion/mf/promociones/activateOne/" +
            me.codigoPromocion;
          axios
            .get(url)
            .then(function (response) {
              console.log(response);
              me.listar = 51;
              me.listarPromociones(
                1,
                "buscar",
                "criterio",
                1,
                "codigoPromocion"
              );
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    cancelarPromocion() {
      let me = this;
      console.log("Cancelar promocion" + this.codigoPromocion);
      var url =
        me.http_ +
        "/acumulacion/mf/promociones/cancelOne/" +
        this.codigoPromocion +
        "/" +
        me.razones;
      me.$swal({
        position: "top-end",
        title:
          "Está seguro de cancelar la promoción con código: " +
          this.codigoPromocion +
          "?",
        text: "¡No podrá revertir el proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .get(url)
            .then(function (response) {
              console.log(response);
              me.listar = 51;
              me.listarPromociones(
                1,
                "buscar",
                "criterio",
                1,
                "codigoPromocion"
              );
              me.$swal({
                //'Cancelada!','Promoción '+codigoPromo+' cancelada.', 'success'
                position: "top-end",
                icon: "success",
                title: "Promoción " + this.codigoPromocion + " cancelada.",
                showConfirmButton: false,
                timer: 1000,
              });
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
      me.cerrarModalExtensionCancel();
    },
    finalizarFinPromocion() {
      let me = this;
      console.log("Cancelar promocion" + this.codigoPromocion);
      var url =
        me.http_ +
        "/acumulacion/mf/promociones/finalizeOne/" +
        this.codigoPromocion +
        "/" +
        me.razones;
      me.$swal({
        position: "top-end",
        title:
          "Está seguro de finalizar la promoción con código: " +
          this.codigoPromocion +
          "?",
        text: "¡No podrá revertir el proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .get(url)
            .then(function (response) {
              console.log(response);
              me.listar = 51;
              me.listarPromociones(
                1,
                "buscar",
                "criterio",
                1,
                "codigoPromocion"
              );
              me.$swal({
                //'Cancelada!','Promoción '+codigoPromo+' cancelada.', 'success'
                position: "top-end",
                icon: "success",
                title: "Promoción " + this.codigoPromocion + " finalizada.",
                showConfirmButton: false,
                timer: 1000,
              });
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
      me.cerrarModalExtensionCancel();
    },
    extenderPromocion() {
      let me = this;
      me.usuarioModifica = localStorage.getItem("user");
      me.$swal({
        position: "top-end",
        title:
          "Está seguro de extender la fecha fin de la promoción de código: " +
          me.codigoPromocion +
          "?",
        text: "¡No podrá revertir el proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          me.$swal({
            //'Cancelada!','Promoción '+codigoPromo+' cancelada.', 'success'
            position: "top-end",
            icon: "success",
            title: "Promoción " + me.codigoPromocion + " extendida.",
            showConfirmButton: false,
            timer: 1000,
          });
          axios
            .post(me.http_ + "/acumulacion/mf/promociones/extendPromociones", {
              codigoPromocion: me.codigoPromocion,
              fechaFin: me.fechaFin.replace("T", " "),
              razones: me.razones,
              usuarioModifica: me.usuarioModifica,
              fechaUltimoCambio: FechaService.fechaHoy(),
            })
            .then(function (response) {
              console.log(response);
              me.listar = 51;
              me.listarPromociones(
                1,
                "buscar",
                "criterio",
                1,
                "codigoPromocion"
              );
              //me.codigoPromocionDuplicar=[];
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });

      me.cerrarModalExtensionCancel();
    },
    obtenerFechas() {
      let me = this;
      let arrayCodExt = [];
      for (let j = 0; j < me.codigoPromocionDuplicar.length; j++) {
        for (let i = 0; i < me.arrayPromocionesAll.length; i++) {
          if (
            me.arrayPromocionesAll[i].codigoPromocion ===
            me.codigoPromocionDuplicar[j]
          ) {
            arrayCodExt.push(new Date(me.arrayPromocionesAll[i].fechaFin));
            i = me.arrayPromocionesAll.length;
          }
        }
      }
      var max = new Date(Math.max.apply(null, arrayCodExt));
      let fech = FechaService.formatoDate(max);
      return fech;
    },
    extenderPromocionMasivo() {
      let me = this;
      let codPrm = 0;
      let arrayCodProEx = [];
      let tamanio = 0;
      me.usuarioModifica = localStorage.getItem("user");
      tamanio = me.codigoPromocionDuplicar.length;
      arrayCodProEx = me.codigoPromocionDuplicar;
      let mensaje = "";
      if (me.codigoPromocionDuplicar.length === 1) {
        mensaje =
          "Está seguro de extender la fecha fin de " +
          me.codigoPromocionDuplicar.length +
          " promoción de código: ";
      } else {
        mensaje =
          "Está seguro de extender la fecha fin de " +
          me.codigoPromocionDuplicar.length +
          " promociones de los siguientes códigos: ";
      }
      me.$swal({
        position: "top-end",
        title: mensaje,
        text: me.codigoPromocionDuplicar,
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          for (let i = 0; i < tamanio; i++) {
            codPrm = arrayCodProEx[i];
            console.log("codigo EXTE, " + codPrm);
            axios
              .post(
                me.http_ + "/acumulacion/mf/promociones/extendPromociones",
                {
                  codigoPromocion: codPrm,
                  fechaFin: me.fechaFin.replace("T", " "),
                  razones: me.razones,
                  usuarioModifica: me.usuarioModifica,
                  fechaUltimoCambio: FechaService.fechaHoy(),
                }
              )
              .then(function (response) {
                console.log(response);
                me.$swal({
                  position: "top-end",
                  icon: "success",
                  title: "Promociones extendidas.",
                  showConfirmButton: false,
                  timer: 1000,
                });
                me.listarPromociones(
                  1,
                  "buscar",
                  "criterio",
                  1,
                  "codigoPromocion"
                );
              })
              .catch(function (error) {
                console.log(error);
              });
          }
          me.codigoPromocionDuplicar = [];
          me.listar = 51;
          //me.listarPromociones(1, "buscar", "criterio", 1, "codigoPromocion");
        }
      });
      //me.codigoPromocionDuplicar = [];
      me.cerrarModalExtensionCancel();
      me.listarPromociones(1, "buscar", "criterio", 1, "codigoPromocion");
    },
    todasSucursal() {
      //let me = this;
    },
    verListarPromociones() {
      let me = this;
      me.listar = 51;
      me.codigoPromocionDuplicar = [];
      me.cargaParametros();
      //me.listarPromociones(1, "buscar", "criterio",1,'codigoPromocion');
    },
    nuevaPlantillaMensajes() {
      let me = this;
      me.listar = 11;
    },
    listarMensajes() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/mensajes/all";
      axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          var respuesta = response.data;
          me.arrayMensajesAll = respuesta;
          console.log(me.arrayMensajesAll);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    asignarMensaje() {
      let me = this;
      me.arrayMensajes.push({
        tipo: me.tipoMensaje,
        mensaje: me.mensajePromo,
      });
      me.listar = 11;
    },
    registrarMensaje() {
      let me = this;
      axios
        .post(me.http_ + "/acumulacion/mf/mensajes/save", {
          IdMensaje: 1,
          descripcion: "Mensajes",
          estado: "Activo",
          tipoMensaje: me.arrayMensajes,
        })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    actualizarMensajepromo() {
      let me = this;
      for (let i = 0; i < me.arrayMensajesPromocionTipos.length; i++) {
        if (i == me.idxMensajePromo) {
          me.arrayMensajesPromocionTipos[i].mensaje = me.mensajePromo;
        }
      }
      console.log(me.arrayMensajesPromocionTipos);
      me.arrayMensajesPromocion[0].tipoMensaje = me.arrayMensajesPromocionTipos;
      me.cerrarModalMensajes();
      me.actualizarEncabezdoPromocion();
    },
    eliminarMensajesPromo(idxx) {
      let me = this;
      me.$swal({
        position: "top-end",
        title: "Está seguro de eliminar el mensaje ?",
        text: "¡No podrá revertir el proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          me.$swal({
            position: "top-end",
            icon: "success",
            title: "Mensaje eliminado.",
            showConfirmButton: false,
            timer: 1000,
          });

          for (let i = 0; i < me.arrayMensajesPromocionTipos.length; i++) {
            if (i == me.idxMensajePromo) {
              me.arrayMensajesPromocionTipos.splice(idxx, 1);
            }
          }
          console.log(me.arrayMensajesPromocionTipos);
          me.arrayMensajesPromocion[0].tipoMensaje =
            me.arrayMensajesPromocionTipos;
          me.actualizarEncabezdoPromocion();
        }
      });
    },
    //vista previa y cambio para codigos nombres
    vistaPreviaMensaj() {
      let me = this;
      let mensajT = "";
      if (me.controlVistaPrevMsj == 0) {
        me.controlVistaPrevMsj = 1;
      } else {
        me.controlVistaPrevMsj = 0;
      }
      mensajT = me.mensajePromo;
      console.log(mensajT);
      for (let i = 0; i < me.arrayVariables.length; i++) {
        var index = mensajT.indexOf(me.arrayVariables[i].nombre);
        let bus = "";
        let rep = "001";
        if (index >= 0) {
          bus = me.arrayVariables[i].nombre;
          rep = me.arrayVariables[i].descripcion;
          me.mensajePromoVistaPrev = mensajT.replace(bus, rep);
          mensajT = me.mensajePromoVistaPrev;
        }
      }
      console.log(mensajT);
      /*
      if (mensajT.indexOf("@Beneficios") >= 0) {
        console.log(mensajT.indexOf("@Beneficios"));
        //me.cargarNombresBenef();
        var url =
        me.http_ +
        "/acumulacion/mf/promociones/procesCode/" +
        me.codigoPromocion;
        axios.get(url)
        .then(function (response) {
          var respuesta = response.data;
          me.arrayCombinacionBenef = respuesta;
          //console.log("1");
          console.log(me.arrayCombinacionBenef);
          let cadeBene = "";
          cadeBene = me.arrayCombinacionBenef.toString().replace(/,/gi, " O TAMBIÉN "); //
          //me.mensajePromoVistaPrev = me.mensajePromoVistaPrev + " " + me.arrayCombinacionBenef.toString();
          me.mensajePromoVistaPrev = me.mensajePromoVistaPrev + " " + cadeBene;
          me.mensajePromo =
          me.mensajePromo + " " + cadeBene.replace("@Beneficios", cadeBene);
        })
        .catch(function (error) {
          console.log(error);
        });
        
      }
      */
      console.log(me.mensajePromoVistaPrev);
    },
    cargarNombresBenef() {
      let me = this;
      var url =
        me.http_ +
        "/acumulacion/mf/promociones/procesCode/" +
        me.codigoPromocion;
      axios
        .get(url)
        .then(function (response) {
          var respuesta = response.data;
          me.arrayCombinacionBenef = respuesta;
          //console.log("1");
          //console.log(me.arrayCombinacionBenef);
        })
        .catch(function (error) {
          console.log(error);
        });
      let cadeBene = "";
      cadeBene = me.arrayCombinacionBenef
        .toString()
        .replace(",", " O TAMBIÉN "); //
      //me.mensajePromoVistaPrev = me.mensajePromoVistaPrev + " " + me.arrayCombinacionBenef.toString();
      me.mensajePromoVistaPrev = me.mensajePromoVistaPrev + " " + cadeBene;
      me.mensajePromo =
        me.mensajePromo + " " + cadeBene.replace("@Beneficios", cadeBene);

      //me.mensajePromo = me.mensajePromoVistaPrev;
    },
    listarVariablesMensajes() {
      let me = this;

      var url = me.http_ + "/acumulacion/mf/mensajes/variables/all";
      axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          var respuesta = response.data;
          me.arrayVariables = respuesta[0].variables;
          //console.log("variables");
          //console.log(me.arrayVariables);
          //for (let value of respuesta[0].variables) {
          //me.arrayVariables.push(value.nombre);
          //}
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarOficinas() {
      let me = this;

      var url = me.http_ + "/acumulacion/mf/registroOficina/all";
      axios
        .get(url)
        .then(function (response) {
          me.oficina.options = response.data;
          me.ajustarOficinas(me.oficina.options);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ajustarOficinas(prd) {
      let me = this;
      let p;
      me.oficina.options = [];
      for (p of prd) {
        p.label = p.oficina + " " + p.nombre_oficina;
        p.value = p.oficina;
        //console.log(p);
        me.oficina.options.push(p);
      }
    },
    listarProveedores() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/proveedores/all/";
      axios
        .get(url)
        .then(function (response) {
          me.proveedor = response.data;
          //console.log(me.proveedor);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarGeneraCobro() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/generacobros/all";
      axios
        .get(url)
        .then(function (response) {
          //console.log(response.data);
          me.arrayGeneraCobro = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarAsumeCategoria() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/asumecategorias/all";
      axios
        .get(url)
        .then(function (response) {
          //console.log(response.data);
          me.arrayAsumeCategoria = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    asignarItemCobro() {
      let me = this;
      console.log("Item cobros");
      console.log(me.arrayCobros.length);
      if (me.tipoPagador === "Farmaenlace") me.listaCodigos = me.empresa_RUC;
      if (me.listaCodigos == "") {
        return;
      }
      if (me.arrayCobros.length > 0) {
        for (let i = 0; i < me.arrayCobros.length; i++) {
          console.log(me.arrayCobros[i].codigoProveedor);
          if (me.listaCodigos == me.arrayCobros[i].codigoProveedor) {
            me.$swal({
              title: "Recuerde",
              icon: "warning",
              text: "Proveedor ya se encuentra asignado.",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
            return;
          }
        }
      }
      if (me.tipoPagador === "Farmaenlace") {
        me.arrayCobros.push({
          metodoAplicacion: me.metodoAplicacion,
          tipoPrecio: me.listaCobro,
          tipoPagador: me.tipoPagador,
          codigoProveedor: me.empresa_RUC,
          valor: me.valorCobro,
        });
      }
      if (me.tipoPagador === "Proveedor") {
        me.arrayCobros.push({
          metodoAplicacion: me.metodoAplicacion,
          tipoPrecio: me.listaCobro,
          tipoPagador: me.tipoPagador,
          codigoProveedor: me.listaCodigos,
          valor: me.valorCobro,
        });
      } else if (me.tipoPagador === "Linea Comercial") {
        me.arrayCobros.push({
          metodoAplicacion: me.metodoAplicacion,
          tipoPrecio: me.listaCobro,
          tipoPagador: me.tipoPagador,
          //codigoProveedor: me.lineaComercial.value.toString(),
          codigoProveedor: me.listaCodigos,
          valor: me.valorCobro,
        });
      }
      me.valorCobro = 0;
      me.listaCodigos = "";
      //console.log(me.arrayCobros);
    },
    eliminarCobrosProv(idx) {
      let me = this;
      for (var i = 0; i < me.arrayCobros.length; i++) {
        if (i === idx) {
          me.arrayCobros.splice(i, 1);
        }
      }
    },
    asignarCobrosProveedor() {
      let me = this;
      let hijoT = [];
      console.log(
        me.condicion_cobros + "--" + me.indicePadreBenef + ".." + me.indicePadre
      );
      if (me.condicion_cobros === 0) {
        for (var i = 0; i < me.arrayItemBenef.length; i++) {
          console.log("recorre cobro " + i);
          if (i === me.indicePadreBenef) {
            console.log("indice cobro " + i);
            me.arrayItemBenef[i].pagadoresDeuda = me.arrayCobros;
          }
        }
        console.log(me.arrayItemBenef);
        me.arrayBeneficios = me.arrayItemBenef;
        me.registrarPromocionBeneficios();
      } else {
        //PARA ASIGNAR COBROS
        for (var j = 0; j < me.arrayItem.length; j++) {
          if (j === me.indicePadre) {
            hijoT = me.arrayItem[j].condiciones;
            //console.log(hijoT);
            for (var k = 0; k < hijoT.length; k++) {
              if (k === me.indicePadreBenef) {
                //console.log("Array-->");
                //console.log(hijoT[k]);
                //console.log("Array-->hj->");
                //console.log(hijoT[k].beneficioProducto);
                //console.log(hijoT[k].beneficioProducto[0].pagadoresDeuda);
                me.arrayItem[j].condiciones[
                  k
                ].beneficioProducto[0].pagadoresDeuda = me.arrayCobros;
              }
            }
          }
        }
        console.log(me.arrayItem);
        me.grupoCondiciones = me.arrayItem;

        me.registrarPromocionCondiciones();
      }
      me.cerrarModalCobros();
    },
    duplicarPromocion(val) {
      // 0 en array 1-n - else el codigoPromo
      let me = this;
      me.usuario = localStorage.getItem("user");
      if (val != 0) {
        me.codigoPromocionDuplicar[0] = val;
      }

      if (me.codigoPromocionDuplicar.length < 1) {
        me.$swal({
          position: "top-end",
          icon: "warning",
          title: "Seleccione al menos una promoción.",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      me.$swal({
        position: "top-end",
        title:
          "Está seguro de duplicar la(s) promoción(es) de código(s): " +
          me.codigoPromocionDuplicar +
          " ?.",
        text: "¡No podrá revertir proceso!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          //for (let i = 0; i < me.codigoPromocionDuplicar.length; i++) {
          axios
            .post(
              me.http_ +
                "/acumulacion/mf/promociones/copy/" +
                me.codigoPromocionDuplicar.toString() +
                "/" +
                me.usuario,
              {}
            )
            .then(function (response) {
              var respuesta = response.data;
              console.log(respuesta);
              if (me.codigoPromocionDuplicar.length == 1) {
                me.verPromocion(respuesta.codigoPromocion, 1);
                //me.btnfinalizarR = 1;
                //me.casos = 51;
              } else {
                me.casos = 51;
                //me.listarPromociones(1, "buscar", "criterio", 0);
                me.listarPromociones(
                  1,
                  "buscar",
                  "criterio",
                  1,
                  "codigoPromocion"
                );
              }
              me.codigoPromocionDuplicar = [];
              me.$swal({
                //'Duplicados!','Promociones duplicadas.', 'success'
                position: "top-end",
                icon: "success",
                title: "Promociones duplicadas.",
                showConfirmButton: false,
                timer: 1000,
              });
            })
            .catch(function (error) {
              console.log(error);
            });
          //}
        }
      });
    },
    insertPalabraClave() {
      let dom = document.getElementById("formula-textarea");
      /*
      console.log(this.palabraClave);
      console.log(this.mensajePromo);
      console.log(dom.selectionStart);
      console.log(dom.selectionEnd);
      console.log(dom.textLength);
      console.log(this.mensajePromo.substring(0, dom.selectionStart));
      */

      this.mensajePromo =
        this.mensajePromo.substring(0, dom.selectionStart) +
        " " +
        this.palabraClave +
        "   " +
        this.mensajePromo.substring(dom.selectionEnd, dom.textLength);
    },
    activarSeleccion() {
      //Activa seleccion para acciones masivas
      let me = this;
      if (me.activarSelect == 0) {
        me.activarSelect = 1;
      } else {
        me.activarSelect = 0;
      }
      me.selectTodo = 0;
      me.codigoPromocionDuplicar = [];
    },
    listarResponsable() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/responsablepromociones/all/";
      axios
        .get(url)
        .then(function (response) {
          me.responsable.options = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarLineaComercial() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/lineacomercial/all";
      axios
        .get(url)
        .then(function (response) {
          me.lineaComercial.options = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    seleccionarTodo() {
      let me = this;

      if (me.selectTodo == 1) {
        console.log("1: " + me.selectTodo);
        me.codigoPromocionDuplicar = [];
      } else {
        console.log("0: " + me.selectTodo);
        for (let i = 0; i < me.arrayPromocionesAll.length; i++) {
          me.codigoPromocionDuplicar[i] =
            me.arrayPromocionesAll[i].codigoPromocion;
        }
      }
    },
    selectAcum() {
      let me = this;
      if (!me.condicionAcumulacion) {
        if (!me.condicionCanje) {
          me.condicionCanje = true;
          //console.log(me.condicionCanje);
        }
      }
    },
    selectCanj() {
      let me = this;
      if (!me.condicionAcumulacion) {
        if (!me.condicionCanje) {
          me.condicionAcumulacion = true;
          //console.log(me.condicionAcumulacion);
        }
      }
    },
    cambiarTipoAcumulacion() {
      let me = this;
      if (me.tipoAcumulacion == "Acumulable") {
        me.esAcumulableCondicion = true;
      }
      if (me.tipoAcumulacion == "No Acumulable") {
        me.esAcumulableCondicion = false;
      }
      console.log(me.esAcumulableCondicion);
    },
    selectFechaInicioAcum() {
      let me = this;
      if (!me.noAplicaFIAC) {
        me.$swal({
          title: "Recuerde",
          icon: "warning",
          text: "Si no selecciona la fecha de inicio de acumulación, la promoción comienza en 'Fecha inicio'",
          //showConfirmButton: false,
          //timer: 2000,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
    },
    verProdCod(texto, ident) {
      let me = this;

      //const Json = JSON.stringify(me.aarray);
      //console.log(Json)

      me.modalVistaPrevia = 1;
      me.textoCodProd = texto;
      if (ident == 0) me.tituloModal = "Productos de condición";
      if (ident == 1) me.tituloModal = "Productos beneficio";
    },
    validarModalidad() {
      let me = this;
      if (me.tipoMF === "Tratamiento Completo") {
        me.tipoAcumulacion = "No Acumulable";
        me.mesPendienteCanje = 1;
      } else me.tipoAcumulacion = "Acumulable";
    },
    verEmpresa() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/empresa/allActive";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.empresa_RUC = response.data.ruc;
          me.empresa_NC = response.data.nombre_razon;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async validarToken() {
      //let me = this;
      let loginResponse = await Token.validarToken(
        localStorage.getItem("token")
      );
      console.log(loginResponse);
      if (loginResponse.data == false) {
        localStorage.removeItem("fechaA");
        localStorage.removeItem("user");
        location.reload();
        return;
      }
    },
    totNumPages() {
      let me = this;
      return Math.ceil(me.arrayPromocionesAll_all.length / me.obj_per_page);
    },
    prevPage() {
      let me = this;
      if (me.current_page_all > 1) {
        me.current_page_all--;
        me.fitrarPromociones(me.current_page_all);
        me.paginaActiva = me.current_page_all;
      }
    },
    nextPage() {
      let me = this;
      if (me.current_page_all < me.totNumPages()) {
        me.current_page_all++;
        me.fitrarPromociones(me.current_page_all);
        me.paginaActiva = me.current_page_all;
      }
    },
    fitrarPromociones(page) {
      let me = this;
      //console.log(page);
      me.paginaActiva = page;
      me.current_page_all = page;
      //var listing_table = document.getElementById("TableList");
      //var page_span = document.getElementById("page");
      let arraTmp = [];
      if (page < 1) page = 1;
      if (page > me.totNumPages()) page = me.totNumPages();
      //listing_table.innerHTML = "";
      for (
        var i = (page - 1) * me.obj_per_page;
        i < page * me.obj_per_page;
        i++
      ) {
        //listing_table.innerHTML += obj[i].number + "<br>";
        if (me.arrayPromocionesAll_pag[i] != null) {
          arraTmp.push(me.arrayPromocionesAll_pag[i]);
        }

        //
      }
      //console.log(arraTmp);
      me.arrayPromocionesAll = arraTmp;
    },
    seleccionarProdCB() {
      let me = this;
      if (me.selectFilterLike == "Productos") me.selectPCB = 1;
      else me.selectPCB = 0;

      me.arrayPromocionesAll = [];
      me.selectCond = 1;
      me.selectBenef = 1;
      me.buscarlike = "";
      me.buscarEstado = "Estado";
      me.buscarModalidad = "0";
      console.log(me.arrayPromocionesAll_all.length);
      me.arrayPromocionesAll = me.arrayPromocionesAll_all;
      me.arrayPromocionesAll_pag = me.arrayPromocionesAll_all;
      me.paginasTotal = Math.ceil(
        me.arrayPromocionesAll.length / me.obj_per_page
      );
      console.log(me.arrayPromocionesAll.length);
      me.fitrarPromociones(1);
    },
    seleccionarProd(valor) {
      let me = this;
      console.log(" Seleccionado: "+ valor);
      if (valor == 1) {
        if (me.selectCond == 1) me.selectCond = 0;
        else if (me.selectCond == 0) me.selectCond = 1;
      }
      if (valor == 2) {
        if (me.selectBenef == 1) me.selectBenef = 0;
        else if (me.selectBenef == 0) me.selectBenef = 1;
      }
      console.log("ingresando 1:"+me.selectCond+" <=-+-=> "+ me.selectBenef);
      me.listarPromocionesLikeCB(2);
      console.log("ingresando 2");
      me.listarPromocionesLikeEstado(2); // 2 es ninguno no valida
      console.log("ingresando 3");
      me.listarPromocionesLikeModalidad();
    },
    listarPromocionesLikeCB(valor) {
      let me = this;
      let arrayFilterP = [];
      let arrayPromoT = [];
      let textoTx = "";

      if (valor == 3) {
        me.buscarEstado = "Estado";
        me.buscarModalidad = "0";
      }

      arrayPromoT = me.arrayPromocionesAll_all;
      console.log(me.selectCond+" <=-+-=> "+ me.selectBenef);
      if (me.selectCond != 0 || me.selectBenef != 0) {
        console.log(me.selectCond+" <=-+ingreso+-=> "+ me.selectBenef);
        console.log(me.buscarlike);
        if (me.buscarlike != "") {
          for (let i = 0; i < me.arrayPromocionesAll_all.length; i++) {
            //console.log("Recorre: " + i + ":"+me.arrayPromocionesAll_all[i].codigoPromocion +" <--> " + me.arrayPromocionesAll_all.length);

            if (me.selectFilterLike == "Nombre") {
              textoTx = me.arrayPromocionesAll_all[i].nombre;
              if (textoTx.indexOf(me.buscarlike.toUpperCase()) != -1) {
                arrayFilterP.push(me.arrayPromocionesAll_all[i]);
              }
            } else {
              let condd = me.buscarProductosVar(me.arrayPromocionesAll_all[i]);
              //console.log(condd);
              if (condd == 1) {
                arrayFilterP.push(me.arrayPromocionesAll_all[i]);
              }
            }
            //arrayProdVar = me.arrayPromocionesAll_all[i].productosVar;
          }
          //console.log(arrayFilterP);
          me.arrayPromocionesAll = arrayFilterP;
          me.paginasTotal = Math.ceil(arrayFilterP.length / me.obj_per_page);
          me.arrayPromocionesAll_pag = arrayFilterP;
          me.arrayPromocionesAll_ES = arrayFilterP;
          me.arrayPromocionesAll_MD = arrayFilterP;
          me.fitrarPromociones(1);
        } else {
          me.arrayPromocionesAll = me.arrayPromocionesAll_all;
          me.paginasTotal = Math.ceil(
            me.arrayPromocionesAll_all.length / me.obj_per_page
          );
          me.arrayPromocionesAll_pag = me.arrayPromocionesAll_all;
          me.arrayPromocionesAll_ES = me.arrayPromocionesAll_all;
          me.arrayPromocionesAll_MD = me.arrayPromocionesAll_all;
          me.fitrarPromociones(1);
        }
        me.listarPromocionesLikeEstado(2); // 2 es ninguno no valida
        me.listarPromocionesLikeModalidad();
      }
      else{
         me.arrayPromocionesAll = [];
         me.arrayPromocionesAll_pag =  [];
         me.arrayPromocionesAll_ES =  [];
         me.arrayPromocionesAll_MD =  [];
      }
    },
    listarPromocionesLikeEstado(valor) {
      let me = this;
      let arrayFilterEM = [];
      let textoTx = "";
      if (valor == 1) {
        //me.buscarModalidad = "0";
      }
      if (me.buscarEstado != "Estado") {
        for (let i = 0; i < me.arrayPromocionesAll_ES.length; i++) {
          textoTx = me.arrayPromocionesAll_ES[i].estado;
          if (textoTx.indexOf(me.buscarEstado) != -1) {
            arrayFilterEM.push(me.arrayPromocionesAll_ES[i]);
          }
        }
        //console.log(arrayFilterEM);
        me.arrayPromocionesAll = arrayFilterEM;
        me.paginasTotal = Math.ceil(arrayFilterEM.length / me.obj_per_page);
        me.arrayPromocionesAll_pag = arrayFilterEM;
        me.arrayPromocionesAll_MD = arrayFilterEM;
        me.fitrarPromociones(1);
      } else {
        me.arrayPromocionesAll = me.arrayPromocionesAll_ES;
        me.paginasTotal = Math.ceil(
          me.arrayPromocionesAll_ES.length / me.obj_per_page
        );
        me.arrayPromocionesAll_pag = me.arrayPromocionesAll_ES;
        me.arrayPromocionesAll_MD = me.arrayPromocionesAll_ES;
        me.fitrarPromociones(1);
      }
      me.listarPromocionesLikeModalidad();
    },
    listarPromocionesLikeModalidad() {
      let me = this;
      let arrayFilterEM = [];
      let textoTx = "";
      if (me.buscarModalidad != "0") {
        for (let i = 0; i < me.arrayPromocionesAll_MD.length; i++) {
          textoTx = me.arrayPromocionesAll_MD[i].tipoMF;
          if (textoTx.indexOf(me.buscarModalidad) != -1) {
            arrayFilterEM.push(me.arrayPromocionesAll_MD[i]);
          }
        }
        //console.log(arrayFilterEM);
        me.arrayPromocionesAll = arrayFilterEM;
        me.paginasTotal = Math.ceil(arrayFilterEM.length / me.obj_per_page);
        me.arrayPromocionesAll_pag = arrayFilterEM;
        //me.arrayPromocionesAll_MD = arrayFilterEM;
        me.fitrarPromociones(1);
      } else {
        me.arrayPromocionesAll = me.arrayPromocionesAll_MD;
        me.paginasTotal = Math.ceil(
          me.arrayPromocionesAll_MD.length / me.obj_per_page
        );
        me.arrayPromocionesAll_pag = me.arrayPromocionesAll_MD;
        //me.arrayPromocionesAll_MD = me.arrayPromocionesAll_MD;
        me.fitrarPromociones(1);
      }
    },
    procesarPromosBusqueda() {
      let me = this;
      me.listarPromocionesLikeCB(0);
      me.listarPromocionesLikeEstado(0);
      me.listarPromocionesLikeModalidad();
    },
    buscarProductosVar(promoPos) {
      let me = this;
      let arrayProdVar = [];
      let condicion = 0;
      let txtCodigo = "";
      let txtNombre = "";
      let resultado = 0;
      arrayProdVar = promoPos.productosVar;

      //console.log(arrayProdVar);
      if (arrayProdVar == null) return 0;
      if (me.selectCond == 1 && me.selectBenef == 1) condicion = 3;
      if (me.selectCond == 1 && me.selectBenef == 0) condicion = 1;
      if (me.selectCond == 0 && me.selectBenef == 1) condicion = 2;
      console.log(me.selectCond + "-- " + me.selectBenef + " Cond: " + condicion);
      for (let j = 0; j < arrayProdVar.length; j++) {
        //console.log(arrayProdVar[i].codigoProducto);
        txtCodigo = arrayProdVar[j].codigoProducto;
        txtNombre = arrayProdVar[j].nombreProducto;
        console.log(condicion +" -> " +txtCodigo +" : " +txtNombre +" <- " +arrayProdVar[j].ubicacion);
        if (
          (arrayProdVar[j].ubicacion == 3 && condicion == 3) ||
          (arrayProdVar[j].ubicacion == 3 && condicion == 1) ||
          (arrayProdVar[j].ubicacion == 3 && condicion == 2)
        ) {
          //ubicacion = 3
          if (
            txtCodigo.indexOf(me.buscarlike) != -1 ||
            txtNombre.indexOf(me.buscarlike.toUpperCase()) != -1
          ) {
            //console.log(arrayProdVar[j].nombreProducto);
            //console.log(arrayProdVar[j].codigoProducto);
            return 1;
          } else resultado = 0;
        } else if (arrayProdVar[j].ubicacion == 2 && condicion == 2) {
          //ubicacion = 2
          if (
            txtCodigo.indexOf(me.buscarlike) != -1 ||
            txtNombre.indexOf(me.buscarlike.toUpperCase()) != -1
          ) {
            return 1;
          } else resultado = 0;
        } else if (arrayProdVar[j].ubicacion == 1 && condicion == 1) {
          //ubicacion = 1
          if (
            txtCodigo.indexOf(me.buscarlike) != -1 ||
            txtNombre.indexOf(me.buscarlike.toUpperCase()) != -1
          ) {
            return 1;
          } else resultado = 0;
        }
      }
      return resultado;
    },
  },
  computed: {
    //Calcular total porcentaje cobro
    calcularTPCobro: function () {
      let me = this;
      var resultado = 0.0;
      console.log(me.arrayCobros.length);
      for (var i = 0; i < me.arrayCobros.length; i++) {
        resultado = resultado + me.arrayCobros[i].valor;
      }
      return resultado;
    },
  },
  async mounted() {
    let me = this;
    /*
    me.validarToken();
    me.modulos = await RolesUser.getRole(localStorage.getItem("user"));
    if(RolesUser.getPermisoPagina(me.modulos,"promociones_mf","promocion")==0){
        return;
    }
    let date = new Date();
    let fechaSesionH =
      String(date.getDate()).padStart(2, "0") +
      "/" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "/" +
      date.getFullYear();
    let fechaSesion = localStorage.getItem("fechaA");
    if (fechaSesion == null) {
      localStorage.removeItem("user");
      location.reload();
      return;
    }
    if (fechaSesionH.valueOf() > fechaSesion.valueOf()) {
      localStorage.removeItem("fechaA");
      localStorage.removeItem("user");
      location.reload();
      return;
    }
    me.usuario = localStorage.getItem("user");
    me.usuarioModifica = localStorage.getItem("user");
*/
    console.log("usuario: " + me.usuario);
    console.log("usuarioMod: " + me.usuario);
    me.listar = 51;
    //me.http_ = me.http_local;
    //me.http_ = me.http_remote;
    me.http_ = IPServie.getURL();
    console.log(me.http_);
    me.controlPaginas = 0;
    me.cargaParametros();
  },
  components: {
    //Encabezado,
    //Multiselect,
    //Producto,
    //Mensaje,

    TextReaderP,
    TextReaderC,
    TextReaderO,
    TextReaderPr,
    TextReaderR,
    TextReaderS,
  },
};
</script>
<!-- <style src="@vueform/multiselect/themes/default.css"></style> -->

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  width: 100%;
}
.row {
  margin: 4px 0;
}
.card-body {
  font-size: 13px;
}
.mostrar {
  display: list-item !important;
  opacity: 1 !important;
  /*position: absolute !important; */
  background-color: #3c29297a !important;
}
.list-group-item:active {
  opacity: 0.5;
  cursor: pointer;
  background: #ecf0f1;
}
.accordion-header {
  padding: 0.01em;
}
</style>

<style>
/** test */
.CellWithComment {
  position: relative;
}

.CellComment {
  display: none;
  position: absolute;
  z-index: 100;
  border: 1px;
  /*background-color:white;*/
  background-color: #a19f9f;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(97, 90, 90);
  border-radius: 6px;
  padding: 3px;
  color: rgb(51, 49, 60);
  top: 30px;
  left: 120px;

  min-height: 100px;
  max-height: 250px;
  width: 150%;
}

.CellWithComment:hover div.CellComment {
  display: block;
}
.CellWithComment .CellComment::after {
  content: "";
  position: absolute;
  top: -10%;
  left: 10%;
  margin-left: 25px;
  border-width: -15px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.men-tooltip {
  max-height: 200px;
  overflow: auto;
  font-weight: normal;
  text-align: justify;
  position: relative;
  top: -10%;
}
/** */
.CellWithComment1 {
  position: relative;
}

.CellComment1 {
  display: none;
  position: absolute;
  z-index: 100;
  border: 1px;
  background-color: white;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(97, 90, 90);
  border-radius: 6px;
  padding: 3px;
  color: rgb(51, 49, 60);
  top: 20px;
  left: -140px;

  min-height: 100px;
  max-height: 250px;
  width: 220px;
}

.CellWithComment1:hover div.CellComment1 {
  display: block;
}
.CellWithComment1 .CellComment1::after {
  content: "";
  position: absolute;
  top: -10%;
  left: 10%;
  margin-left: 25px;
  border-width: -15px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
</style>
<style>
.tab-cabecere {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #eeeeee;
}
.tab-head {
  font-size: 10px;
  border: 0.5px;
  background: #fdf8e4;
}
</style>
<!--parael buscar -->

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 90px;
  height: 13px;
}

.switch input {
  opacity: 0;
  width: 100;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /*
      background-color: #2196f3;
      */
  background-color: #139ab8;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 11px;
  width: 11px;
  left: 1px;
  bottom: 1px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #139ab8;
}

input:focus + .slider {
  box-shadow: 0 0 1px #5cad8a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(36px);
  -ms-transform: translateX(6px);
  transform: translateX(77px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 0px;
}

.slider.round:before {
  border-radius: 0%;
}
</style>
